import debug, { debug as debug$1 } from 'debug';
import { configureChains, createConfig, watchAccount, disconnect, getWalletClient, getPublicClient, getAccount } from '@wagmi/core';
import { w3mProvider, w3mConnectors, EthereumClient } from '@web3modal/ethereum';
import * as ethereum from '@web3modal/ethereum';
export { ethereum as web3modalEthereum };
import { EventEmitter } from 'eventemitter3';
import { isSchemaV2 } from '@storyverseco/svs-story-suite';
import axios from 'axios';
import { SvsSignerValidator } from '@storyverseco/svs-signer-validator';
import { Web3Modal } from '@web3modal/html';
import { mainnet, goerli } from '@wagmi/core/chains';
import { connectToChild } from 'penpal';
import detectEthereumProvider from '@metamask/detect-provider';
import userAgent from '@storyverseco/user-agent';

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var lib = {};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

var tslib_es6 = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
};

var tslib_es6$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	__addDisposableResource: __addDisposableResource,
	get __assign () { return __assign; },
	__asyncDelegator: __asyncDelegator,
	__asyncGenerator: __asyncGenerator,
	__asyncValues: __asyncValues,
	__await: __await,
	__awaiter: __awaiter,
	__classPrivateFieldGet: __classPrivateFieldGet,
	__classPrivateFieldIn: __classPrivateFieldIn,
	__classPrivateFieldSet: __classPrivateFieldSet,
	__createBinding: __createBinding,
	__decorate: __decorate,
	__disposeResources: __disposeResources,
	__esDecorate: __esDecorate,
	__exportStar: __exportStar,
	__extends: __extends,
	__generator: __generator,
	__importDefault: __importDefault,
	__importStar: __importStar,
	__makeTemplateObject: __makeTemplateObject,
	__metadata: __metadata,
	__param: __param,
	__propKey: __propKey,
	__read: __read,
	__rest: __rest,
	__runInitializers: __runInitializers,
	__setFunctionName: __setFunctionName,
	__spread: __spread,
	__spreadArray: __spreadArray,
	__spreadArrays: __spreadArrays,
	__values: __values,
	default: tslib_es6
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(tslib_es6$1);

var ConditionWaiter$1 = {};

Object.defineProperty(ConditionWaiter$1, "__esModule", { value: true });
ConditionWaiter$1.ConditionWaiter = void 0;
function defaultCondition(value) {
    return !!value;
}
class ConditionWaiter {
    constructor(initialValue, condition) {
        this.value = undefined;
        this.resolves = [];
        if (!condition) {
            condition = defaultCondition;
        }
        this.value = initialValue;
        this.condition = condition;
    }
    checkAndMaybeResolve() {
        if (this.resolves.length === 0) {
            return;
        }
        if (!this.condition(this.value)) {
            return;
        }
        this.resolves.forEach((resolve) => resolve(this.value));
        this.resolves = [];
    }
    setCondition(condition) {
        this.condition = condition;
    }
    set(value) {
        this.value = value;
        this.checkAndMaybeResolve();
    }
    get() {
        return this.value;
    }
    wait() {
        if (this.condition(this.value)) {
            return Promise.resolve(this.value);
        }
        return new Promise((resolve) => this.resolves.push(resolve));
    }
}
ConditionWaiter$1.ConditionWaiter = ConditionWaiter;

var NumberUtils = {};

var hasRequiredNumberUtils;

function requireNumberUtils () {
	if (hasRequiredNumberUtils) return NumberUtils;
	hasRequiredNumberUtils = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.clamp = exports.daysToMs = exports.hoursToMs = exports.minutesToMs = exports.secondsToMs = exports.msToDays = exports.msToHours = exports.msToMinutes = exports.msToSeconds = exports.dayInMs = exports.hourInMs = exports.minuteInMs = exports.secondInMs = void 0;
		exports.secondInMs = 1000;
		exports.minuteInMs = 60 * 1000;
		exports.hourInMs = 60 * 60 * 1000;
		exports.dayInMs = 24 * 60 * 60 * 1000;
		function msToSeconds(ms) {
		    return ms / exports.secondInMs;
		}
		exports.msToSeconds = msToSeconds;
		function msToMinutes(ms) {
		    return ms / exports.minuteInMs;
		}
		exports.msToMinutes = msToMinutes;
		function msToHours(ms) {
		    return ms / exports.hourInMs;
		}
		exports.msToHours = msToHours;
		function msToDays(ms) {
		    return ms / exports.dayInMs;
		}
		exports.msToDays = msToDays;
		function secondsToMs(seconds) {
		    return seconds * exports.secondInMs;
		}
		exports.secondsToMs = secondsToMs;
		function minutesToMs(minutes) {
		    return minutes * exports.minuteInMs;
		}
		exports.minutesToMs = minutesToMs;
		function hoursToMs(hours) {
		    return hours * exports.hourInMs;
		}
		exports.hoursToMs = hoursToMs;
		function daysToMs(days) {
		    return days * exports.dayInMs;
		}
		exports.daysToMs = daysToMs;
		function clamp(value, min, max) {
		    return value < min ? min : value > max ? max : value;
		}
		exports.clamp = clamp;
		
	} (NumberUtils));
	return NumberUtils;
}

var SvsNavbarApi = {};

var hasRequiredSvsNavbarApi;

function requireSvsNavbarApi () {
	if (hasRequiredSvsNavbarApi) return SvsNavbarApi;
	hasRequiredSvsNavbarApi = 1;
	Object.defineProperty(SvsNavbarApi, "__esModule", { value: true });
	
	return SvsNavbarApi;
}

var SvsProvider = {};

var hasRequiredSvsProvider;

function requireSvsProvider () {
	if (hasRequiredSvsProvider) return SvsProvider;
	hasRequiredSvsProvider = 1;
	Object.defineProperty(SvsProvider, "__esModule", { value: true });
	SvsProvider.SvsProvider = void 0;
	var SvsProvider$1;
	(function (SvsProvider) {
	    SvsProvider["WalletConnect"] = "walletconnect";
	    // Metamask = 'metamask',
	    // LegacyWalletConnect = 'legacywalletconnect',
	})(SvsProvider$1 || (SvsProvider.SvsProvider = SvsProvider$1 = {}));
	
	return SvsProvider;
}

var WaitUtils = {};

var hasRequiredWaitUtils;

function requireWaitUtils () {
	if (hasRequiredWaitUtils) return WaitUtils;
	hasRequiredWaitUtils = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.waitForExpectedValue = exports.suppressCancelled = exports.waitForSecondsCancelable = exports.waitForMsCancelable = exports.waitForSeconds = exports.waitForMs = exports.PromiseCancelledError = exports.cancelledErrorName = void 0;
		exports.cancelledErrorName = 'PromiseCancelled';
		class PromiseCancelledError extends Error {
		    constructor() {
		        super('Promise manually cancelled');
		        this.name = exports.cancelledErrorName;
		    }
		}
		exports.PromiseCancelledError = PromiseCancelledError;
		function waitForMs(ms) {
		    return new Promise((resolve) => setTimeout(resolve, ms));
		}
		exports.waitForMs = waitForMs;
		function waitForSeconds(seconds) {
		    return waitForMs(seconds * 1000);
		}
		exports.waitForSeconds = waitForSeconds;
		function waitForMsCancelable(ms) {
		    let timeout;
		    let promiseReject;
		    const promise = new Promise((resolve, reject) => {
		        promiseReject = reject;
		        timeout = setTimeout(resolve, ms);
		    }).then(() => {
		        timeout = null;
		        promiseReject = null;
		    });
		    return {
		        promise,
		        cancel() {
		            if (!timeout) {
		                return;
		            }
		            clearTimeout(timeout);
		            timeout = null;
		            promiseReject(new PromiseCancelledError());
		            promiseReject = null;
		        },
		    };
		}
		exports.waitForMsCancelable = waitForMsCancelable;
		function waitForSecondsCancelable(seconds) {
		    return waitForMsCancelable(seconds * 1000);
		}
		exports.waitForSecondsCancelable = waitForSecondsCancelable;
		function suppressCancelled(promise) {
		    return promise.catch((e) => {
		        if (e.name !== exports.cancelledErrorName) {
		            throw e;
		        }
		        return undefined;
		    });
		}
		exports.suppressCancelled = suppressCancelled;
		function defaultExpectedCondition(value) {
		    return !!value;
		}
		function createDefaultExpectedOptions() {
		    return {
		        condition: defaultExpectedCondition,
		        retryOnError: true,
		        maxRetries: 5,
		        retryDelay: 1000,
		        incrementalFactor: 1,
		        retryMaxDelay: 5000,
		    };
		}
		function waitForExpectedValue(fn, options) {
		    const opts = {
		        ...createDefaultExpectedOptions(),
		        ...options,
		    };
		    let cancelled = false;
		    let waitCancel = null;
		    const cancel = () => {
		        cancelled = true;
		        waitCancel?.();
		    };
		    const promise = new Promise(async (resolve, reject) => {
		        let lastError;
		        for (let i = 0; i < opts.maxRetries; i += 1) {
		            if (cancelled) {
		                reject(new PromiseCancelledError());
		                return;
		            }
		            try {
		                const value = await fn();
		                // success, exit
		                if (opts.condition(value)) {
		                    resolve(value);
		                    return;
		                }
		                // condition is false
		                lastError = new Error('Condition failed');
		                opts.retryCallback?.(lastError, i, opts.maxRetries);
		            }
		            catch (e) {
		                lastError = e;
		                // if not retrying on error, reject and exit
		                if (!opts.retryOnError) {
		                    reject(e);
		                    return;
		                }
		                lastError = e;
		                opts.retryCallback?.(e, i, opts.maxRetries);
		            }
		            const factor = opts.incrementalFactor ?? 1;
		            const delay = Math.min(Math.pow(factor, i) * opts.retryDelay, opts.retryMaxDelay);
		            const { promise: delayPromise, cancel: delayCancel } = waitForMsCancelable(delay);
		            const suppressedDelayPromise = suppressCancelled(delayPromise);
		            waitCancel = delayCancel;
		            await suppressedDelayPromise;
		            waitCancel = null;
		        }
		        if (!lastError) {
		            lastError = new Error('Unknown error (No more retries)');
		        }
		        reject(lastError);
		        return;
		    });
		    return {
		        promise,
		        cancel,
		    };
		}
		exports.waitForExpectedValue = waitForExpectedValue;
		
	} (WaitUtils));
	return WaitUtils;
}

var StringUtils = {};

var hasRequiredStringUtils;

function requireStringUtils () {
	if (hasRequiredStringUtils) return StringUtils;
	hasRequiredStringUtils = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.truncateAddress = exports.tokenReplace = exports.ltgtRegex = exports.bracketsRegex = void 0;
		exports.bracketsRegex = /\$?\{\s*([a-zA-Z0-9_]+)\s*\}/gi;
		exports.ltgtRegex = /<\s*([a-zA-Z0-9_]+)\s*>/gi;
		/**
		 * Interpolates a string with a specified token map. Optionally strict that will throw an error if there is no matching string token in the mapping.
		 *
		 * The token pattern is `{tokenName}`.
		 *
		 * If `ltgt` is true, the token pattern is `<tokenName>`.
		 *
		 * @param str The string with string tokens.
		 * @param tokens The token map to replace string tokens with.
		 * @param strict If true, it will throw an error if there is a string token that is not in the specified token map.
		 * @param ltgt If true, it will
		 * @returns interpolated string.
		 */
		function tokenReplace(str, tokens, strict = false, ltgt = false) {
		    const regex = ltgt ? exports.ltgtRegex : exports.bracketsRegex;
		    return str.replace(regex, (_substring, p1) => {
		        if (p1 && p1 in tokens && typeof tokens[p1] === 'string') {
		            return tokens[p1];
		        }
		        // if no match and strict, throw error
		        if (strict) {
		            throw new Error(`tokenReplace: Missing "${p1}" string token`);
		        }
		        // if no match, replace with empty string
		        return '';
		    });
		}
		exports.tokenReplace = tokenReplace;
		function truncateAddress(address) {
		    if (!address) {
		        return null;
		    }
		    if (address.length <= 9) {
		        return address;
		    }
		    // u2026 = ellipsis
		    return address.slice(0, 5) + '\u2026' + address.slice(-4);
		}
		exports.truncateAddress = truncateAddress;
		
	} (StringUtils));
	return StringUtils;
}

var ContentType = {};

var hasRequiredContentType;

function requireContentType () {
	if (hasRequiredContentType) return ContentType;
	hasRequiredContentType = 1;
	Object.defineProperty(ContentType, "__esModule", { value: true });
	ContentType.ContentType = void 0;
	var ContentType$1;
	(function (ContentType) {
	    ContentType["Json"] = "application/json";
	    ContentType["Text"] = "text/plain";
	    ContentType["Html"] = "text/html";
	    ContentType["Form"] = "application/x-www-form-urlencoded";
	})(ContentType$1 || (ContentType.ContentType = ContentType$1 = {}));
	
	return ContentType;
}

var SvsNavbarEvent = {};

var hasRequiredSvsNavbarEvent;

function requireSvsNavbarEvent () {
	if (hasRequiredSvsNavbarEvent) return SvsNavbarEvent;
	hasRequiredSvsNavbarEvent = 1;
	Object.defineProperty(SvsNavbarEvent, "__esModule", { value: true });
	SvsNavbarEvent.SvsNavbarEvent = void 0;
	var SvsNavbarEvent$1;
	(function (SvsNavbarEvent) {
	    SvsNavbarEvent["Any"] = "any";
	    SvsNavbarEvent["LoginStateChanged"] = "loginstatechanged";
	    SvsNavbarEvent["WalletChanged"] = "walletchanged";
	    SvsNavbarEvent["ProviderTypeChanged"] = "providertypechanged";
	    SvsNavbarEvent["RefreshIframeRequested"] = "refreshiframerequested";
	    SvsNavbarEvent["PageRequested"] = "pagerequested";
	    SvsNavbarEvent["HostedAppLoaded"] = "hostedapploaded";
	    SvsNavbarEvent["LoadingVideoRequested"] = "loadingvideorequested";
	    SvsNavbarEvent["TriggerShare"] = "triggershare";
	    SvsNavbarEvent["TriggerShareResult"] = "triggershareresult";
	    SvsNavbarEvent["TriggerShareResultError"] = "triggershareresulterror";
	    SvsNavbarEvent["LegacyWCError"] = "legacywcerror";
	    // mint events from main-site or whatever minting parent
	    SvsNavbarEvent["MintPresignStarted"] = "mintpresignstarted";
	    SvsNavbarEvent["MintPresignEnded"] = "mintpresignended";
	    SvsNavbarEvent["MintPresignError"] = "mintpresignerror";
	    SvsNavbarEvent["MintTxCreateStarted"] = "minttxcreatestarted";
	    SvsNavbarEvent["MintTxCreateEnded"] = "minttxcreateended";
	    SvsNavbarEvent["MintTxCreateError"] = "minttxcreateerror";
	    SvsNavbarEvent["MintStarted"] = "mintstarted";
	    SvsNavbarEvent["MintEnded"] = "mintended";
	    SvsNavbarEvent["MintError"] = "minterror";
	    SvsNavbarEvent["MintTxWaitStarted"] = "minttxwaitstarted";
	    SvsNavbarEvent["MintTxWaitEnded"] = "minttxwaitended";
	    SvsNavbarEvent["MintTxWaitError"] = "minttxwaiterror";
	    SvsNavbarEvent["MintTokenWaitStarted"] = "minttokenwaitstarted";
	    SvsNavbarEvent["MintTokenWaitEnded"] = "minttokenwaitended";
	    SvsNavbarEvent["MintTokenWaitError"] = "minttokenwaiterror";
	})(SvsNavbarEvent$1 || (SvsNavbarEvent.SvsNavbarEvent = SvsNavbarEvent$1 = {}));
	
	return SvsNavbarEvent;
}

var LoadingVideo = {};

var hasRequiredLoadingVideo;

function requireLoadingVideo () {
	if (hasRequiredLoadingVideo) return LoadingVideo;
	hasRequiredLoadingVideo = 1;
	Object.defineProperty(LoadingVideo, "__esModule", { value: true });
	LoadingVideo.StaticLoadingVideo = void 0;
	var StaticLoadingVideo;
	(function (StaticLoadingVideo) {
	    StaticLoadingVideo["Default"] = "default";
	})(StaticLoadingVideo || (LoadingVideo.StaticLoadingVideo = StaticLoadingVideo = {}));
	
	return LoadingVideo;
}

var SaleContract = {};

var hasRequiredSaleContract;

function requireSaleContract () {
	if (hasRequiredSaleContract) return SaleContract;
	hasRequiredSaleContract = 1;
	Object.defineProperty(SaleContract, "__esModule", { value: true });
	
	return SaleContract;
}

var SvsTwitterService = {};

var TwtAuthVersion = {};

var hasRequiredTwtAuthVersion;

function requireTwtAuthVersion () {
	if (hasRequiredTwtAuthVersion) return TwtAuthVersion;
	hasRequiredTwtAuthVersion = 1;
	Object.defineProperty(TwtAuthVersion, "__esModule", { value: true });
	TwtAuthVersion.TwtAuthVersion = void 0;
	var TwtAuthVersion$1;
	(function (TwtAuthVersion) {
	    TwtAuthVersion["V1Write"] = "v1write";
	    TwtAuthVersion["V1Read"] = "v1read";
	    // do we want to expose v1dm here?
	    TwtAuthVersion["V2"] = "v2";
	})(TwtAuthVersion$1 || (TwtAuthVersion.TwtAuthVersion = TwtAuthVersion$1 = {}));
	
	return TwtAuthVersion;
}

var hasRequiredSvsTwitterService;

function requireSvsTwitterService () {
	if (hasRequiredSvsTwitterService) return SvsTwitterService;
	hasRequiredSvsTwitterService = 1;
	Object.defineProperty(SvsTwitterService, "__esModule", { value: true });
	SvsTwitterService.isTwtCreds = SvsTwitterService.isTwtCredsV2 = SvsTwitterService.isTwtCredsV1 = SvsTwitterService.TwtAuthErrorType = SvsTwitterService.TwtSearchParam = void 0;
	const TwtAuthVersion_1 = requireTwtAuthVersion();
	var TwtSearchParam;
	(function (TwtSearchParam) {
	    TwtSearchParam["Auth"] = "auth";
	    TwtSearchParam["AuthError"] = "authError";
	})(TwtSearchParam || (SvsTwitterService.TwtSearchParam = TwtSearchParam = {}));
	var TwtAuthErrorType;
	(function (TwtAuthErrorType) {
	    TwtAuthErrorType["Denied"] = "denied";
	})(TwtAuthErrorType || (SvsTwitterService.TwtAuthErrorType = TwtAuthErrorType = {}));
	function isTwtCredsV1(obj) {
	    return Boolean(obj &&
	        (obj.authVersion === TwtAuthVersion_1.TwtAuthVersion.V1Write || obj.authVersion === TwtAuthVersion_1.TwtAuthVersion.V1Read) &&
	        typeof obj.accessToken === 'string' &&
	        obj.accessToken &&
	        typeof obj.accessTokenSecret === 'string' &&
	        obj.accessTokenSecret &&
	        typeof obj.userName === 'string' &&
	        obj.userName &&
	        typeof obj.userId === 'string' &&
	        obj.userId);
	}
	SvsTwitterService.isTwtCredsV1 = isTwtCredsV1;
	function isTwtCredsV2(obj) {
	    return Boolean(obj &&
	        obj.authVersion === TwtAuthVersion_1.TwtAuthVersion.V2 &&
	        typeof obj.bearerToken === 'string' &&
	        typeof obj.userName === 'string' &&
	        obj.userName &&
	        typeof obj.userId === 'string' &&
	        obj.userId &&
	        Array.isArray(obj.scopes) &&
	        obj.scopes.every((scope) => typeof scope === 'string'));
	}
	SvsTwitterService.isTwtCredsV2 = isTwtCredsV2;
	function isTwtCreds(obj) {
	    return isTwtCredsV1(obj) || isTwtCredsV2(obj);
	}
	SvsTwitterService.isTwtCreds = isTwtCreds;
	
	return SvsTwitterService;
}

var SvsErrors = {};

var hasRequiredSvsErrors;

function requireSvsErrors () {
	if (hasRequiredSvsErrors) return SvsErrors;
	hasRequiredSvsErrors = 1;
	Object.defineProperty(SvsErrors, "__esModule", { value: true });
	SvsErrors.TwtAuthDeniedError = SvsErrors.TwtAuthError = SvsErrors.SvsAlreadySubbedError = SvsErrors.SvsAuthDeniedError = SvsErrors.SvsAuthError = SvsErrors.SvsRestApiError = SvsErrors.RequiresTwtScopeError = SvsErrors.RequiresTwtAuthError = void 0;
	class RequiresTwtAuthError extends Error {
	    constructor(authVersion, message = `This operation requires auth version "${authVersion}"`) {
	        super(message);
	        this.authVersion = authVersion;
	        this.name = 'RequiresTwtAuthError';
	        this.requiresTwtAuthError = true;
	    }
	    static isError(obj) {
	        return Boolean(obj?.requiresTwtAuthError);
	    }
	}
	SvsErrors.RequiresTwtAuthError = RequiresTwtAuthError;
	class RequiresTwtScopeError extends Error {
	    constructor(scopes, message = `This operation requires scopes: ${scopes.join(', ')}`) {
	        super(message);
	        this.scopes = scopes;
	        this.name = 'RequiresTwtAuthError';
	        this.requiresTwtScopeError = true;
	    }
	    static isError(obj) {
	        return Boolean(obj?.requiresTwtScopeError);
	    }
	}
	SvsErrors.RequiresTwtScopeError = RequiresTwtScopeError;
	class SvsRestApiError extends Error {
	    constructor(statusCode, message = `SVS Rest API error (${statusCode})`, responseText, userFriendlyMessage) {
	        super(message);
	        this.statusCode = statusCode;
	        this.responseText = responseText;
	        this.userFriendlyMessage = userFriendlyMessage;
	        this.name = 'SvsRestApiError';
	        this.svsRestApiError = true;
	        if (responseText) {
	            try {
	                this.responseJson = JSON.parse(responseText);
	            }
	            catch (e) {
	                // do nothing
	            }
	        }
	    }
	    static isError(obj) {
	        return Boolean(obj?.svsRestApiError);
	    }
	}
	SvsErrors.SvsRestApiError = SvsRestApiError;
	class SvsAuthError extends Error {
	    constructor(message = 'Auth error occurred') {
	        super(message);
	        this.svsAuthError = true;
	        this.name = 'SvsAuthError';
	    }
	    static isError(error) {
	        return Boolean(error?.svsAuthError);
	    }
	}
	SvsErrors.SvsAuthError = SvsAuthError;
	class SvsAuthDeniedError extends Error {
	    constructor(message = 'User denied auth') {
	        super(message);
	        this.svsAuthDeniedError = true;
	        this.name = 'SvsAuthDeniedError';
	    }
	    static isError(error) {
	        return Boolean(error?.svsAuthDeniedError);
	    }
	}
	SvsErrors.SvsAuthDeniedError = SvsAuthDeniedError;
	class SvsAlreadySubbedError extends Error {
	    constructor(message = 'Already subscribed') {
	        super(message);
	        this.svsAlreadySubbedError = true;
	        this.name = 'SvsAlreadySubbedError';
	    }
	    static isError(error) {
	        return Boolean(error?.svsAlreadySubbedError);
	    }
	}
	SvsErrors.SvsAlreadySubbedError = SvsAlreadySubbedError;
	class TwtAuthError extends Error {
	    constructor(authErrorValue, message = `Unexpected Twitter auth error: ${authErrorValue}`) {
	        super(message);
	        this.authErrorValue = authErrorValue;
	        this.twtTwtAuthError = true;
	        this.name = 'TwtAuthError';
	    }
	    static isError(error) {
	        return Boolean(error?.twtTwtAuthError);
	    }
	}
	SvsErrors.TwtAuthError = TwtAuthError;
	class TwtAuthDeniedError extends Error {
	    constructor(message = 'User denied Twitter auth') {
	        super(message);
	        this.twtTwtAuthDeniedError = true;
	        this.name = 'TwtAuthDeniedError';
	    }
	    static isError(error) {
	        return Boolean(error?.twtTwtAuthDeniedError);
	    }
	}
	SvsErrors.TwtAuthDeniedError = TwtAuthDeniedError;
	
	return SvsErrors;
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SvsErrors = exports.ContentType = exports.StringUtils = exports.WaitUtils = exports.SvsProvider = exports.NumberUtils = exports.ConditionWaiter = void 0;
	const tslib_1 = require$$0;
	var ConditionWaiter_1 = ConditionWaiter$1;
	Object.defineProperty(exports, "ConditionWaiter", { enumerable: true, get: function () { return ConditionWaiter_1.ConditionWaiter; } });
	exports.NumberUtils = tslib_1.__importStar(requireNumberUtils());
	tslib_1.__exportStar(requireSvsNavbarApi(), exports);
	var SvsProvider_1 = requireSvsProvider();
	Object.defineProperty(exports, "SvsProvider", { enumerable: true, get: function () { return SvsProvider_1.SvsProvider; } });
	exports.WaitUtils = tslib_1.__importStar(requireWaitUtils());
	exports.StringUtils = tslib_1.__importStar(requireStringUtils());
	var ContentType_1 = requireContentType();
	Object.defineProperty(exports, "ContentType", { enumerable: true, get: function () { return ContentType_1.ContentType; } });
	tslib_1.__exportStar(requireSvsNavbarEvent(), exports);
	tslib_1.__exportStar(requireLoadingVideo(), exports);
	tslib_1.__exportStar(requireSaleContract(), exports);
	tslib_1.__exportStar(requireSvsTwitterService(), exports);
	exports.SvsErrors = tslib_1.__importStar(requireSvsErrors());
	tslib_1.__exportStar(requireTwtAuthVersion(), exports);
	
} (lib));

function loginStateFinished(loginState) {
    switch (loginState) {
        case 2 /* LoginState.LoggedIn */:
        case 4 /* LoginState.LoggedOut */:
        case 5 /* LoginState.Errored */:
            return true;
        default:
            return false;
    }
}

const log$5 = debug('svsnavbar:sharedwalletapi');
const { getCoreMessageFromFullMessage, getSignedMessageWithSigner } = SvsSignerValidator;
var ServiceEndpoint;
(function (ServiceEndpoint) {
    ServiceEndpoint["PocAuthChoiceCreation"] = "/poc/authorizeChoiceCreation";
    ServiceEndpoint["PocAuthOptionMinting"] = "/poc/authorizeOptionMinting";
    ServiceEndpoint["GetContractAddress"] = "/m/storyverse_plot/methods/currentContractAddress";
    ServiceEndpoint["GetWallet"] = "/nb/getWallet";
})(ServiceEndpoint || (ServiceEndpoint = {}));
class SharedWalletApi {
    constructor(config, messageAndSigPrefix) {
        this.config = config;
        this.messageAndSigPrefix = messageAndSigPrefix;
        this.serviceAxios = null;
        this.tokenIdToSaveCount = {};
        this.serviceAxios = axios.create({
            baseURL: config.serviceProxyUrl,
            validateStatus: () => true, // let client deal with errors
        });
    }
    async fetchWallet(walletAddress) {
        const response = await this.serviceRequest(`${ServiceEndpoint.GetWallet}/${walletAddress}`);
        return response.data;
    }
    getStorageKeyForMessageAndSignature(address) {
        return `${this.messageAndSigPrefix}:${address}`;
    }
    checkStoredSignedMessageAndSignature(address) {
        address = address.toLowerCase();
        log$5('checkStoredSignedMessageAndSignature: ', address);
        const storageKey = this.getStorageKeyForMessageAndSignature(address);
        const stored = localStorage.getItem(storageKey);
        if (stored) {
            log$5('checkStoredSignedMessageAndSignature stored:', stored);
            try {
                // doing try-catch in case json parse fails
                const parsed = JSON.parse(stored);
                if (typeof parsed.message !== 'string') {
                    log$5('Old message format. Invalidating.');
                    throw new Error('Old message format detected');
                }
                const coreMessage = getCoreMessageFromFullMessage(parsed.message);
                const messageAndSig = {
                    message: parsed.message,
                    signature: parsed.signature,
                };
                const timestamp = coreMessage.timestamp;
                if (timestamp && timestamp + lib.NumberUtils.daysToMs(1) >= new Date().getTime() - 500) {
                    log$5('return stored message signing');
                    return messageAndSig;
                }
                else {
                    return undefined;
                }
            }
            catch (e) {
                localStorage.removeItem(storageKey);
                return undefined;
            }
        }
    }
    /**
     * start metamask flow to get signedMessage and Signature
     * @param signer (metamask)
     * @param messageData optional arbitrary object stored within the message, under 'data' field
     * @returns
     */
    async startGetSignedMessageAndSignature(signer, address, messageData = undefined) {
        if (!address) {
            address = signer.account.address;
        }
        address = address.toLowerCase();
        const storageKey = this.getStorageKeyForMessageAndSignature(address);
        // if stored, check timestamp, and if valid, return stored value.
        const stored = this.checkStoredSignedMessageAndSignature(address);
        if (stored) {
            return stored;
        }
        // prompt user to sign
        try {
            const messageAndSig = await getSignedMessageWithSigner(address, signer, messageData);
            log$5('message and signature: ', messageAndSig);
            localStorage.setItem(storageKey, JSON.stringify(messageAndSig));
            return messageAndSig;
        }
        catch (e) {
            log$5('User rejected message signing', e);
            return undefined;
        }
    }
    removeMessageAndSignature(address) {
        const storageKey = this.getStorageKeyForMessageAndSignature(address);
        localStorage.removeItem(storageKey);
    }
    async serviceRequest(endpoint, options = { maxRetries: 3, retryDelayMs: 1000 }) {
        const { promise } = lib.WaitUtils.waitForExpectedValue(() => this.serviceAxios.get(endpoint), {
            condition: (response) => !options.validateStatus || options.validateStatus(response.status),
            retryOnError: true,
            retryDelay: options.retryDelayMs,
            maxRetries: options.maxRetries,
            retryCallback(reason, retries, maxRetries) {
                log$5(`serviceRequest: error occurred during get (retry ${retries + 1}/${maxRetries}):`, reason);
            },
        });
        return await promise;
    }
    async serviceSignedRequest(address, endpoint, data, options = { maxRetries: 3, retryDelayMs: 1000 }) {
        const messageAndSig = this.checkStoredSignedMessageAndSignature(address);
        if (!messageAndSig) {
            log$5('serviceSignedRequest: Could not get message and sig after login. This should not be happening');
            throw new Error('serviceSignedRequest: Could not get message and sig after login');
        }
        const { promise } = lib.WaitUtils.waitForExpectedValue(() => this.serviceAxios.post(endpoint, {
            message: messageAndSig.message,
            signature: messageAndSig.signature,
            ...data,
        }), {
            condition: (response) => !options.validateStatus || options.validateStatus(response.status),
            retryOnError: true,
            retryDelay: options.retryDelayMs,
            maxRetries: options.maxRetries,
            retryCallback(reason, retries, maxRetries) {
                log$5(`serviceSignedRequest: error occurred during get (retry ${retries + 1}/${maxRetries}):`, reason);
            },
        });
        return await promise;
    }
    async savePlotTitle(wallet, { tokenId, title }) {
        const messageAndSig = this.checkStoredSignedMessageAndSignature(wallet.address);
        if (!messageAndSig) {
            throw new Error('Could not get message and sig after login, this should not be happening');
        }
        const result = await axios.post(`${this.config.persistPlotServerPrefix}${tokenId}/title`, {
            title,
            message: messageAndSig.message,
            signature: messageAndSig.signature,
        });
        return result.data;
    }
    async saveStory(opts) {
        // temporary
        // return await this._saveStory({storyId, data, force})
        return Promise.resolve({
            status: 200,
            message: 'This method is temporary blocked',
        });
    }
    async saveStoryForShare(opts) {
        return await this._saveStory({
            share: true,
            ...opts,
        });
    }
    async _saveStory(params) {
        const story = typeof params.data === 'string' ? JSON.parse(params.data) : params.data;
        const isV2 = isSchemaV2(story);
        /**
         * This should be a temporary change to support both V1 and V2 schemas until
         * V2 is released to prod, then we can remove the V1 hanlder.
         */
        if (isV2) {
            return this._saveStoryV2(params);
        }
        return this._saveStoryV1(params);
    }
    async _saveStoryV1({ storyId, data, force, sharePayload, share = false, }) {
        log$5(`saveStoryV1: ${storyId}, ${share ? 'with share' : 'no share'}`);
        // temporary: all users are anons
        /*
        if (!(await this.logIn())) {
          log('saveStory: could not save because log in failed')
          return undefined
        }
        const messageAndSig = this.checkStoredSignedMessageAndSignature(this.address)
        if (!messageAndSig) {
          throw new Error('Could not get message and sig after login, this should not be happening')
        }
        */
        /**
         * This logic is temporary to support Schema V1 and V2. Whenever V2 is released to prod
         * do remove the handling for V1 stories as migrations are already in place.
         */
        const dialog = typeof data === 'string' ? JSON.parse(data) : data;
        if (!dialog.saveCount) {
            dialog.saveCount = 0;
        }
        const oldSaveCount = dialog.saveCount;
        if (storyId) {
            // increment saveCount
            if (!this.tokenIdToSaveCount[storyId] || dialog.saveCount > this.tokenIdToSaveCount[storyId]) {
                this.tokenIdToSaveCount[storyId] = dialog.saveCount;
            }
            // we could technically do dialog.saveCount = ++session.saveCount,
            // but this is easier to read and debug
            this.tokenIdToSaveCount[storyId] += 1;
            dialog.saveCount = this.tokenIdToSaveCount[storyId];
        }
        try {
            // temporary: all users are anons
            /* const wallet = await this.getWallet({force: false})
            // /story/:walletAddress(0x[0-9a-fA-F]{40})/:storyId/:dialogVersion([0-9]+)
            const url = wallet.address
              ? `${this.persistStoryServerPrefix}${wallet.address}/${storyId}/${dialog.saveCount}`
              : `${this.persistStoryServerPrefix}0x0/`
            */
            const url = `${this.config.persistStoryServerPrefix}0x0/share/`;
            // storyverse creator should handle 409 conflict to optionally retry with force
            const response = await axios.post(url, {
                data: JSON.stringify(dialog),
                force,
                share,
                payload: sharePayload,
            }, {
                // allow 2xx and 3xx and 409
                validateStatus: (status) => (status >= 200 && status < 400) || status === 409,
            });
            // if unsuccessful status, revert session saveCount
            if (storyId && (response.status < 200 || response.status >= 400)) {
                this.tokenIdToSaveCount[storyId] = oldSaveCount;
            }
            return {
                status: response.status,
                message: response.data || undefined,
            };
        }
        catch (e) {
            if (storyId) {
                // if error, revert session saveCount
                this.tokenIdToSaveCount[storyId] = oldSaveCount;
            }
            // rethrowing for client
            throw e;
        }
    }
    async _saveStoryV2({ storyId, data, force, sharePayload, share = false, }) {
        log$5(`saveStoryV2_boo: ${storyId}, ${share ? 'with share' : 'no share'}`);
        // temporary: all users are anons
        /*
        if (!(await this.logIn())) {
          log('saveStory: could not save because log in failed')
          return undefined
        }
        const messageAndSig = this.checkStoredSignedMessageAndSignature(this.address)
        if (!messageAndSig) {
          throw new Error('Could not get message and sig after login, this should not be happening')
        }
        */
        /**
         * This logic is temporary to support Schema V1 and V2. Whenever V2 is released to prod
         * do remove the handling for V1 stories as migrations are already in place.
         */
        const story = typeof data === 'string' ? JSON.parse(data) : data;
        const oldSaveCount = story.metadata.saveCount;
        if (storyId) {
            // increment saveCount
            if (!this.tokenIdToSaveCount[storyId] || story.metadata.saveCount > this.tokenIdToSaveCount[storyId]) {
                this.tokenIdToSaveCount[storyId] = story.metadata.saveCount;
            }
            // we could technically do dialog.saveCount = ++session.saveCount,
            // but this is easier to read and debug
            this.tokenIdToSaveCount[storyId] += 1;
            story.metadata.saveCount = this.tokenIdToSaveCount[storyId];
        }
        try {
            // temporary: all users are anons
            /* const wallet = await this.getWallet({force: false})
            // /story/:walletAddress(0x[0-9a-fA-F]{40})/:storyId/:dialogVersion([0-9]+)
            const url = wallet.address
              ? `${this.persistStoryServerPrefix}${wallet.address}/${storyId}/${dialog.saveCount}`
              : `${this.persistStoryServerPrefix}0x0/`
            */
            const url = `${this.config.persistStoryServerPrefix}0x0/share/`;
            // storyverse creator should handle 409 conflict to optionally retry with force
            const response = await axios.post(url, {
                data: JSON.stringify(story),
                force,
                share,
                payload: sharePayload,
            }, {
                // allow 2xx and 3xx and 409
                validateStatus: (status) => (status >= 200 && status < 400) || status === 409,
            });
            // if unsuccessful status, revert session saveCount
            if (storyId && (response.status < 200 || response.status >= 400)) {
                this.tokenIdToSaveCount[storyId] = oldSaveCount;
            }
            return {
                status: response.status,
                message: response.data || undefined,
            };
        }
        catch (e) {
            if (storyId) {
                // if error, revert session saveCount
                this.tokenIdToSaveCount[storyId] = oldSaveCount;
            }
            // rethrowing for client
            throw e;
        }
    }
    async saveNftStoryForWriter(wallet, opts) {
        log$5(`saveStory: ${opts.storyId}`);
        const messageAndSig = this.checkStoredSignedMessageAndSignature(wallet.address);
        if (!messageAndSig) {
            throw new Error('Could not get message and sig after login, this should not be happening');
        }
        const dialog = typeof opts.data === 'string' ? JSON.parse(opts.data) : opts.data;
        const authorAddress = opts.authorAddress ?? wallet.address;
        let url = opts.storyId
            ? `${this.config.persistStoryServerPrefix}${authorAddress}/${opts.storyId}/nft`
            : `${this.config.persistStoryServerPrefix}${authorAddress}/nft`;
        // storyverse creator should handle 409 conflict to optionally retry with force
        const response = await axios.post(url, {
            story: JSON.stringify(dialog),
            signature: messageAndSig.signature,
            message: messageAndSig.message,
        }, {
            // allow 2xx and 3xx and 409
            validateStatus: (status) => (status >= 200 && status < 400) || status === 409,
        });
        return {
            status: response.status,
            message: response.data || undefined,
        };
    }
    async getNFTStoryForStoryWriter(wallet, opts) {
        const messageAndSig = this.checkStoredSignedMessageAndSignature(wallet.address);
        if (!messageAndSig) {
            throw new Error('Could not get message and sig after login, this should not be happening');
        }
        if (wallet?.address) {
            const response = await axios.post(`${this.config.persistStoryServerPrefix}${opts.authorAddress}/${opts.storyId}/${opts.dialogVersion}/nft`, {
                signature: messageAndSig.signature,
                message: messageAndSig.message,
            });
            return Promise.resolve(response.data);
        }
        else {
            log$5('Invalid wallet address');
            throw new Error('Invalid wallet address');
        }
    }
    async getNFTStory(opts) {
        if (!opts.authorAddress) {
            const msg = 'Token id is missing';
            log$5(msg);
            throw new Error(msg);
        }
        const response = await axios.get(`${this.config.persistStoryServerPrefix}${opts.authorAddress}/${opts.storyId}/${opts.dialogVersion}/nft/${opts.tokenId}`);
        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    }
    async recordChoice(wallet, opts) {
        log$5(`record choice: ${opts.storyId}`);
        if (!opts.recordChoiceData) {
            throw new Error('Missing record choice data');
        }
        const messageAndSig = this.checkStoredSignedMessageAndSignature(wallet.address);
        if (!messageAndSig) {
            throw new Error('Could not get message and sig after login, this should not be happening');
        }
        // check if wallet owns the nft
        const tokens = [];
        Object.values(wallet.storyNFTs).forEach((value) => {
            // todo decode tokenId, should we decode these token ids in the backend?
            tokens.push(...value.tokens);
        });
        // todo enable this
        // if(!tokens.includes(opts.tokenId)) {
        //   throw new Error('Wallet does not own the token');
        // }
        let url = `${this.config.persistStoryServerPrefix}${opts.authorAddress}/${opts.storyId}/${opts.tokenId}/nft/recordChoice`;
        const response = await axios.post(url, {
            data: opts.recordChoiceData,
            signature: messageAndSig.signature,
            tokenOwnerWalletAddress: wallet.address,
            message: messageAndSig.message,
        }, {
            // allow 2xx and 3xx and 409
            validateStatus: (status) => (status >= 200 && status < 400) || status === 409,
        });
        return {
            status: response.status,
            message: response.data || undefined,
        };
    }
    async randomReveal(wallet, opts) {
        log$5(`random reveal: ${opts.storyId}`);
        if (!opts.randomRevealData) {
            throw new Error('Missing random reveal data');
        }
        const messageAndSig = this.checkStoredSignedMessageAndSignature(wallet.address);
        if (!messageAndSig) {
            throw new Error('Could not get message and sig after login, this should not be happening');
        }
        let url = `${this.config.persistStoryServerPrefix}${opts.authorAddress}/${opts.storyId}/${opts.tokenId}/nft/randomReveal`;
        const response = await axios.post(url, {
            data: opts.randomRevealData,
            signature: messageAndSig.signature,
            tokenOwnerWalletAddress: wallet.address,
            message: messageAndSig.message,
        }, {
            // allow 2xx and 3xx and 409
            validateStatus: (status) => (status >= 200 && status < 400) || status === 409,
        });
        return {
            status: response.status,
            message: response.data || undefined,
        };
    }
    async getTemplatesFor(wallet) {
        const response = await axios.get(`${this.config.templateApiPrefix}${wallet.address || ''}`);
        return response.data;
    }
    async getAvailableAssets(wallet) {
        const response = await axios.get(`${this.config.assetsApiPrefix}${wallet.address || ''}`);
        return response.data;
    }
    async authorizeChoiceCreation(wallet, payload) {
        const response = await this.serviceSignedRequest(wallet.address, ServiceEndpoint.PocAuthChoiceCreation, payload);
        log$5('authorizeChoiceCreation response:', response);
        return response;
    }
    async authorizeOptionMinting(wallet, payload) {
        const response = await this.serviceSignedRequest(wallet.address, ServiceEndpoint.PocAuthOptionMinting, payload);
        log$5('authorizeOptionMinting response:', response);
        return response;
    }
    async isNFTStoryOwner(wallet, opts) {
        const url = `${this.config.persistStoryServerPrefix}${opts.authorAddress}/${opts.storyId}/${opts.tokenId}/nft/owner`;
        const response = await axios.post(url, {
            tokenOwnerWalletAddress: wallet.address,
        }, {
            // allow 2xx and 3xx and 409
            validateStatus: (status) => (status >= 200 && status < 400) || status === 409,
        });
        return response.data;
    }
    async fetchContractAddress() {
        if (this.config.foundersPassContract) {
            return this.config.foundersPassContract;
        }
        const response = await this.serviceRequest(ServiceEndpoint.GetContractAddress);
        return response.data?.result?.address ?? null;
    }
    createLoggedOutWallet() {
        return {
            nfts: {},
            storyNFTs: {},
            flags: {
                loggedIn: false,
                founder: false,
                storyNFTEditor: false,
            },
        };
    }
}

const log$4 = debug('svsnavbar:wcwalletservice');
const messageAndSigPrefix = 'svs.nb.wc.ms:1.0.0';
const chainIdMap = {
    [mainnet.id]: mainnet,
    [goerli.id]: goerli,
};
var InitState;
(function (InitState) {
    InitState[InitState["Idle"] = 0] = "Idle";
    InitState[InitState["Initting"] = 1] = "Initting";
    InitState[InitState["Initted"] = 2] = "Initted";
})(InitState || (InitState = {}));
const manualDisconnectThreshold = 1000; // ms
class WCWalletService extends EventEmitter {
    constructor(config) {
        super();
        this.config = config;
        this.loginStateWaiter = new lib.ConditionWaiter(0 /* LoginState.Idle */, loginStateFinished);
        this.inittedWaiter = new lib.ConditionWaiter(InitState.Idle, (initState) => initState === InitState.Initted);
        this.walletPopulated = false;
        this.disconnectTime = 0;
        const chains = this.config.chainIds.map((chainId) => chainIdMap[chainId]);
        if (chains.some((chain) => !chain)) {
            throw new Error('One or more of the chain IDs are not supported');
        }
        this.chains = chains;
        this.sharedWalletApi = new SharedWalletApi(config, messageAndSigPrefix);
        this.wallet = this.sharedWalletApi.createLoggedOutWallet();
        const projectId = this.config.walletConnectProjectId;
        const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);
        this.provider = publicClient;
        this.wagmiClient = createConfig({
            autoConnect: true,
            connectors: w3mConnectors({
                projectId,
                chains,
            }),
            publicClient,
        });
        this.ethereumClient = new EthereumClient(this.wagmiClient, chains);
        this.web3modal = new Web3Modal({ projectId }, this.ethereumClient);
        this.unsubWatchAccount = watchAccount(this.onAccountChange.bind(this));
        this.init();
    }
    get loggedIn() {
        return this.wallet.flags.loggedIn;
    }
    get initted() {
        return this.inittedWaiter.get() === InitState.Initted;
    }
    async init(opts) {
        if (this.initted) {
            return;
        }
        if (this.inittedWaiter.get() === InitState.Initting) {
            await this.inittedWaiter.wait();
            return;
        }
        this.inittedWaiter.set(InitState.Initting);
        const account = await this.waitForWCAccount();
        let staleSession = true;
        if (account.isConnected) {
            log$4('init: Using logged in user', account.address);
            const addressLC = account.address.toLowerCase();
            this.wallet.address = addressLC;
            this.wallet.flags.loggedIn = true;
            staleSession = false;
            const messageAndSig = this.sharedWalletApi.checkStoredSignedMessageAndSignature(addressLC);
            if (messageAndSig) {
                this.wallet.messageAndSig = messageAndSig;
            }
            this.emit(lib.SvsNavbarEvent.WalletChanged, this.wallet);
            this.setLoginState(2 /* LoginState.LoggedIn */);
        }
        // disconnect WC so it shows the wallet provider icons on next login
        if (staleSession) {
            log$4('init: disconnecting wc');
            await disconnect();
        }
        this.inittedWaiter.set(InitState.Initted);
    }
    waitForInit() {
        return this.inittedWaiter.wait().then((state) => state === InitState.Initted);
    }
    signUp(messageData, opts) {
        return this.logIn(messageData, opts);
    }
    async logIn(messageData, opts = { messageAndSig: true }) {
        await this.startLogin(messageData, opts);
        return this.wallet.flags.loggedIn;
    }
    async signSession(messageData) {
        if (!this.wallet.address) {
            throw new Error('WCWalletService: Must connect wallet first before signing this session');
        }
        const address = this.wallet.address.toLowerCase();
        const existingMessageAndSig = this.sharedWalletApi.checkStoredSignedMessageAndSignature(address);
        if (existingMessageAndSig) {
            // already validly signed, so return true
            // we could check for messageData same-ness, but we're not really using this anyway
            return true;
        }
        log$4('signSession', { messageData });
        const signer = await getWalletClient();
        if (!signer) {
            throw new Error('WCWalletService: connected but missing signer for unknown reasons');
        }
        const messageAndSig = await this.sharedWalletApi.startGetSignedMessageAndSignature(signer, address, messageData);
        if (!messageAndSig) {
            // user declined to sign
            return false;
        }
        this.wallet.messageAndSig = messageAndSig;
        this.emit(lib.SvsNavbarEvent.WalletChanged, this.wallet);
        return true;
    }
    async logOut() {
        await this.startLogout();
    }
    async getWallet(optsOrForce) {
        /*
        This function is sometimes the first call by the client.
        */
        const opts = {
            force: typeof optsOrForce === 'boolean' ? optsOrForce : optsOrForce?.force ?? false,
            providerType: typeof optsOrForce === 'object' ? optsOrForce.providerType : undefined,
        };
        // already connected and logged in
        if (!opts.force && this.wallet.flags.loggedIn && this.walletPopulated) {
            return this.wallet;
        }
        await this.init();
        // no wallet connected
        if (!this.wallet.address) {
            log$4('getWallet: Not logged in');
            return this.wallet;
        }
        // wallet connected but not logged in or wallet populated by backend
        let changed = false;
        if (!this.wallet.flags.loggedIn || !this.walletPopulated || opts.force) {
            const walletData = await this.fetchWallet(this.wallet.address);
            this.wallet = walletData;
            this.wallet.flags.loggedIn = true;
            changed = true;
        }
        log$4('getWallet: logged in');
        this.wallet.messageAndSig = this.sharedWalletApi.checkStoredSignedMessageAndSignature(this.wallet.address);
        if (changed) {
            this.emit(lib.SvsNavbarEvent.WalletChanged, this.wallet);
        }
        return this.wallet;
    }
    isWeb3Available() {
        // in theory, any client should have web3 availability via web3modal
        return Promise.resolve(true);
    }
    saveStory(opts) {
        return this.sharedWalletApi.saveStory(opts);
    }
    saveStoryForShare(opts) {
        return this.sharedWalletApi.saveStoryForShare(opts);
    }
    async getTemplatesFor() {
        log$4('Loading templates');
        try {
            const wallet = await this.getWallet({ force: false });
            return await this.sharedWalletApi.getTemplatesFor(wallet);
        }
        catch (e) {
            log$4('Impossible to get templates');
            // rethrowing for client
            throw e;
        }
    }
    async getAvailableAssets() {
        log$4('Loading assets');
        try {
            const wallet = await this.getWallet({ force: false });
            return await this.sharedWalletApi.getAvailableAssets(wallet);
        }
        catch (e) {
            log$4('Impossible to get assets');
            // rethrowing for client
            throw e;
        }
    }
    authorizeChoiceCreation(payload) {
        return this.sharedWalletApi.authorizeChoiceCreation(this.wallet, payload);
    }
    authorizeOptionMinting(payload) {
        return this.sharedWalletApi.authorizeOptionMinting(this.wallet, payload);
    }
    async sendTransaction(tx) {
        const signer = await getWalletClient();
        if (!signer) {
            throw new Error('Missing signer');
        }
        if (!tx.chain) {
            const chain = this.chains.find((chain) => Boolean(chain)); // get a valid chain
            if (!chain) {
                throw new Error('sendTransaction: Transaction has no specified and no valid chain configured');
            }
            tx.chain = chain;
        }
        const txResponse = await signer.sendTransaction(tx);
        // clone via stringify/parse to remove any non-serializable stuff
        const clonedResponse = JSON.parse(JSON.stringify(txResponse));
        return clonedResponse;
    }
    async getTransactionReceipt(txHash) {
        const chainId = this.config.chainIds[0];
        const provider = getPublicClient({ chainId });
        if (!provider) {
            throw new Error('getTransactionReceipt: Missing provider');
        }
        const hash = (typeof txHash === 'string' ? txHash : await txHash);
        log$4(`getTransactionReceipt: fetching ${hash}`);
        // retry internally as a workaround to occasional WC JSON-RPC errors
        const { promise } = lib.WaitUtils.waitForExpectedValue(() => provider.getTransactionReceipt({ hash }), {
            condition: () => true,
            maxRetries: 10,
            retryDelay: 1000,
            incrementalFactor: 2,
            retryMaxDelay: 10000,
            retryOnError: true,
            retryCallback(reason, retries, maxRetries) {
                log$4(`get tx receipt failed. retrying... (${retries}/${maxRetries})`, reason);
            },
        });
        return await promise;
    }
    async savePlotTitle(optsOrTokenId, title) {
        const opts = typeof optsOrTokenId === 'string'
            ? {
                tokenId: optsOrTokenId,
                title: title,
            }
            : optsOrTokenId;
        const loggedIn = await this.logIn();
        if (!loggedIn) {
            log$4('saveTitle: could not save because log in failed');
            return undefined;
        }
        return await this.sharedWalletApi.savePlotTitle(this.wallet, opts);
    }
    async getNFTStoryForStoryWriter(opts) {
        log$4('fetching nft story for writer');
        try {
            const wallet = await this.getWallet({ force: false });
            return await this.sharedWalletApi.getNFTStoryForStoryWriter(wallet, opts);
        }
        catch (e) {
            log$4('Impossible to get story');
            // rethrowing for client
            throw e;
        }
    }
    async saveNftStoryForWriter(opts) {
        log$4(`saveStory: ${opts.storyId}`);
        if (!this.loggedIn && !(await this.logIn())) {
            log$4('saveNftStory: could not save because log in failed');
            return undefined;
        }
        return await this.sharedWalletApi.saveNftStoryForWriter(this.wallet, opts);
    }
    async recordChoice(opts) {
        log$4(`record choice: ${opts.storyId}`);
        if (!this.loggedIn && !(await this.logIn())) {
            log$4('recordChoice: log in failed');
            return undefined;
        }
        return await this.sharedWalletApi.recordChoice(this.wallet, opts);
    }
    async randomReveal(opts) {
        log$4(`random reveal: ${opts.storyId}`);
        if (!this.loggedIn && !(await this.logIn())) {
            log$4('randomReveal: log in failed');
            return undefined;
        }
        return await this.sharedWalletApi.randomReveal(this.wallet, opts);
    }
    async getNFTStory(opts) {
        log$4('fetching nft story');
        try {
            return await this.sharedWalletApi.getNFTStory(opts);
        }
        catch (e) {
            log$4('Impossible to get story');
            // rethrowing for client
            throw e;
        }
    }
    async isNFTStoryOwner(opts) {
        log$4('checking if user is token owner');
        if (!this.loggedIn && !(await this.logIn())) {
            log$4('isNFTStoryOwner: log in failed');
            return undefined;
        }
        try {
            const wallet = await this.getWallet({ force: false });
            return await this.sharedWalletApi.isNFTStoryOwner(wallet, opts);
        }
        catch (e) {
            log$4('isNFTStoryOwner error:', e);
            // rethrowing for client
            throw e;
        }
    }
    getWagmiClient() {
        return this.wagmiClient;
    }
    getW3MEthereumClient() {
        return this.ethereumClient;
    }
    changeSvsProvider(opts) {
        // throw new Error('Unsupported method')
        return Promise.resolve(opts.providerType); // we're forcing WC, so just assume we're giving them what they want
    }
    getSvsProvider() {
        return Promise.resolve(lib.SvsProvider.WalletConnect);
    }
    emit(event, ...args) {
        // overriding to emulate an "any" event
        const emitted = super.emit(event, ...args);
        super.emit(lib.SvsNavbarEvent.Any, event, ...args);
        return emitted;
    }
    fetchWallet(walletAddress) {
        return this.sharedWalletApi.fetchWallet(walletAddress);
    }
    async startLogin(messageData, opts) {
        this.disconnectTime = 0; // reset manual disconnect time
        await this.init();
        if (this.loginStateWaiter.get() === 1 /* LoginState.LoggingIn */) {
            // in the middle of logging in, so ignore
            return;
        }
        if (this.wallet.flags.loggedIn) {
            const messageAndSig = this.sharedWalletApi.checkStoredSignedMessageAndSignature(this.wallet.address);
            if (messageAndSig) {
                log$4('startLogin: Already logged in', this.wallet.address);
                return;
            }
            // stale, so resetting wallet
            this.wallet = this.sharedWalletApi.createLoggedOutWallet();
        }
        try {
            log$4('startLogin: starting login');
            this.setLoginState(1 /* LoginState.LoggingIn */);
            log$4('startLogin: pre waitForWCAccount');
            const account = await this.waitForWCAccount();
            log$4('startLogin: post waitForWCAccount');
            if (account.isConnected) {
                // disconnect so it shows the wallet provider icons
                log$4('startLogin: disconnecting wc');
                await disconnect();
            }
            log$4('startLogin: fetching signer after modal login');
            const signer = await new Promise((resolve, reject) => {
                const unsubs = [];
                function unsubAll() {
                    unsubs.forEach((unsub) => unsub());
                }
                unsubs.push(watchAccount((account) => {
                    if (account.isConnected) {
                        log$4('startLogin: signer: account connected');
                        resolve(getWalletClient());
                        unsubAll();
                        return;
                    }
                }));
                unsubs.push(this.web3modal.subscribeModal((state) => {
                    if (state.open) {
                        log$4('modal open');
                    }
                    else {
                        log$4('modal closed');
                        unsubAll();
                        // still need to fully disconnect
                        disconnect().then(() => {
                            reject(new Error('Web3Modal closed'));
                        });
                    }
                }));
                this.web3modal.openModal();
            });
            log$4('startLogin: pre message and sig');
            let messageAndSig = null;
            if (opts.messageAndSig) {
                messageAndSig = await this.sharedWalletApi.startGetSignedMessageAndSignature(signer, undefined, messageData);
                if (!messageAndSig) {
                    log$4('startLogin: User rejected signing message, login aborted');
                    this.setLoginState(4 /* LoginState.LoggedOut */);
                    this.emit(lib.SvsNavbarEvent.WalletChanged, this.wallet);
                    return;
                }
                log$4('startLogin: post message and sig');
            }
            else {
                log$4('Ninja login: Skipping message and signature request');
            }
            const signerAddress = signer.account.address; // we already have new signer, so get address from signer
            this.wallet = this.sharedWalletApi.createLoggedOutWallet(); // reset
            this.wallet.address = signerAddress.toLowerCase();
            this.wallet.messageAndSig = messageAndSig;
            this.wallet.flags.loggedIn = true;
            this.walletPopulated = false;
            this.setLoginState(2 /* LoginState.LoggedIn */);
            this.emit(lib.SvsNavbarEvent.WalletChanged, this.wallet);
        }
        catch (e) {
            log$4('startLogin: Error occurred while loggin in:', e);
            this.setLoginState(4 /* LoginState.LoggedOut */);
        }
    }
    async startLogout() {
        this.disconnectTime = Date.now();
        this.setLoginState(3 /* LoginState.LoggingOut */);
        if (this.wallet.address) {
            this.sharedWalletApi.removeMessageAndSignature(this.wallet.address);
        }
        await disconnect();
        this.wallet = this.sharedWalletApi.createLoggedOutWallet();
        this.walletPopulated = false;
        this.setLoginState(4 /* LoginState.LoggedOut */);
        this.emit(lib.SvsNavbarEvent.WalletChanged, this.wallet);
    }
    async waitForWCAccount() {
        let account = getAccount();
        log$4('waitforWCAccount', account);
        if (account.isConnected || account.isDisconnected) {
            return account;
        }
        if (account.isConnecting || account.isReconnecting) {
            account = await new Promise((resolve) => {
                const unsub = watchAccount((a) => {
                    if (a.isConnected || a.isDisconnected) {
                        unsub();
                        resolve(a);
                    }
                });
            });
        }
        return account;
    }
    async onAccountChange(accountResult) {
        if (!this.initted) {
            return;
        }
        if (this.loginStateWaiter.get() === 1 /* LoginState.LoggingIn */) {
            // in the middle of logging in, so ignore
            return;
        }
        log$4('onAccountChange', accountResult);
        // workaround for walletconnect trying to reconnect immediately after a manual disconnect
        if (accountResult.isConnecting && Date.now() - this.disconnectTime <= manualDisconnectThreshold) {
            await disconnect();
        }
        // we don't care about isConnecting or isReconnecting by this point
        if (accountResult.isConnecting || accountResult.isReconnecting) {
            return;
        }
        if (accountResult.isDisconnected) {
            if (this.loggedIn) {
                await this.startLogout(); // already emits navbar event
            }
            return;
        }
        if (accountResult.isConnected) {
            const resultAddress = accountResult.address.toLowerCase();
            const walletAddress = this.wallet.address?.toLowerCase();
            if (resultAddress === walletAddress) {
                // changed into the same wallet so nothing is needed
                return;
            }
            try {
                const messageAndSig = this.sharedWalletApi.checkStoredSignedMessageAndSignature(resultAddress);
                const oldWalletPopulated = this.walletPopulated;
                this.wallet = this.sharedWalletApi.createLoggedOutWallet(); // reset
                this.walletPopulated = false;
                // if (!messageAndSig) {
                //   log('No valid message and sig, requesting signing')
                //   this.setLoginState(LoginState.LoggingIn)
                //   const signer = await getWalletClient()
                //   messageAndSig = await this.sharedWalletApi.startGetSignedMessageAndSignature(signer)
                // }
                // if (!messageAndSig) {
                //   log('User rejected signing message, login aborted')
                //   this.startLogout() // already emits navbar event and sets loginState
                //   return
                // }
                if (oldWalletPopulated) {
                    // populate via fetchWallet since it was populated before
                    this.wallet = await this.sharedWalletApi.fetchWallet(resultAddress);
                    this.wallet.flags.loggedIn = true;
                    this.walletPopulated = true;
                }
                else {
                    // no need to populate
                    this.wallet.address = resultAddress;
                    this.wallet.flags.loggedIn = true;
                }
                if (messageAndSig) {
                    this.wallet.messageAndSig = messageAndSig;
                }
                this.setLoginState(2 /* LoginState.LoggedIn */);
                this.emit(lib.SvsNavbarEvent.WalletChanged, this.wallet);
            }
            catch (e) {
                log$4('onAccountChange error:', e);
                this.setLoginState(4 /* LoginState.LoggedOut */);
            }
        }
    }
    setLoginState(loginState) {
        if (this.loginStateWaiter.get() === loginState) {
            return;
        }
        this.loginStateWaiter.set(loginState);
        log$4('Login state', loginState);
        this.emit(lib.SvsNavbarEvent.LoginStateChanged, loginState);
    }
}

const defaultProviderType = lib.SvsProvider.WalletConnect;
class MultiWalletService extends EventEmitter {
    constructor(config) {
        super();
        this.config = config;
        this.serviceMap = {};
        this.currentProvider = config.providerType ?? defaultProviderType;
        const bindedEmit = this.emit.bind(this);
        const wcWalletService = new WCWalletService(config);
        wcWalletService.on(lib.SvsNavbarEvent.Any, bindedEmit);
        this.serviceMap[lib.SvsProvider.WalletConnect] = wcWalletService;
    }
    get loggedIn() {
        const service = this.getProvider();
        return service.loggedIn;
    }
    get initted() {
        const service = this.getProvider();
        return service.initted;
    }
    init(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.init(opts);
    }
    waitForInit() {
        const service = this.getProvider();
        return service.waitForInit();
    }
    signUp(messageData, opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.signUp(messageData, opts);
    }
    logIn(messageData, opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.logIn(messageData, opts);
    }
    signSession(messageData, opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.signSession(messageData, opts);
    }
    logOut(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.logOut(opts);
    }
    getWallet(optsOrForce) {
        const providerType = typeof optsOrForce === 'object' ? optsOrForce?.providerType : undefined;
        const service = this.getProvider({ providerType });
        return service.getWallet(optsOrForce);
    }
    isWeb3Available(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.isWeb3Available(opts);
    }
    saveStory(optsOrTokenId, data, force) {
        const providerType = typeof optsOrTokenId === 'object' ? optsOrTokenId?.providerType : undefined;
        const service = this.getProvider({ providerType });
        return service.saveStory(optsOrTokenId, data, force);
    }
    saveStoryForShare(optsOrTokenId, data, force) {
        const providerType = typeof optsOrTokenId === 'object' ? optsOrTokenId?.providerType : undefined;
        const service = this.getProvider({ providerType });
        return service.saveStoryForShare(optsOrTokenId, data, force);
    }
    getTemplatesFor() {
        const service = this.getProvider();
        return service.getTemplatesFor();
    }
    getAvailableAssets() {
        const service = this.getProvider();
        return service.getAvailableAssets();
    }
    authorizeChoiceCreation(payload) {
        const service = this.getProvider();
        return service.authorizeChoiceCreation(payload);
    }
    authorizeOptionMinting(payload) {
        const service = this.getProvider();
        return service.authorizeOptionMinting(payload);
    }
    isNFTStoryOwner(opts) {
        const service = this.getProvider({ providerType: opts.providerType });
        return service.isNFTStoryOwner(opts);
    }
    sendTransaction(tx) {
        const service = this.getProvider();
        return service.sendTransaction(tx);
    }
    getTransactionReceipt(txHash) {
        const service = this.getProvider();
        return service.getTransactionReceipt(txHash);
    }
    savePlotTitle(optsOrTokenId, title) {
        const service = this.getProvider();
        return service.savePlotTitle(optsOrTokenId, title);
    }
    getNFTStoryForStoryWriter(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.getNFTStoryForStoryWriter(opts);
    }
    saveNftStoryForWriter(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.saveNftStoryForWriter(opts);
    }
    recordChoice(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.recordChoice(opts);
    }
    randomReveal(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.randomReveal(opts);
    }
    getNFTStory(opts) {
        const service = this.getProvider({ providerType: opts?.providerType });
        return service.getNFTStory(opts);
    }
    getWagmiClient() {
        const service = this.getProvider({ providerType: lib.SvsProvider.WalletConnect });
        return service.getWagmiClient?.();
    }
    getW3MEthereumClient() {
        const service = this.getProvider({ providerType: lib.SvsProvider.WalletConnect });
        return service.getW3MEthereumClient?.();
    }
    async changeSvsProvider(opts) {
        const providerType = opts.providerType ?? defaultProviderType;
        if (!this.serviceMap[providerType]) {
            throw new Error(`Unsupported provider type "${providerType}"`);
        }
        const oldProvider = this.currentProvider;
        this.currentProvider = providerType;
        if (oldProvider !== providerType) {
            await this.serviceMap[this.currentProvider].init();
            this.emit(lib.SvsNavbarEvent.ProviderTypeChanged, providerType);
        }
        return providerType;
    }
    getSvsProvider() {
        return Promise.resolve(this.currentProvider);
    }
    emit(event, ...args) {
        // Overriding to emulate an "any" event
        const emitted = super.emit(event, ...args);
        super.emit(lib.SvsNavbarEvent.Any, event, ...args);
        return emitted;
    }
    getProvider(opts) {
        const provider = opts?.providerType ?? this.currentProvider;
        const service = this.serviceMap[provider];
        if (!service) {
            throw new Error(`Unsupported provider type "${provider}"`);
        }
        return service;
    }
}

const log$3 = debug('svsnavbar:writerservice');
const { waitForMs } = lib.WaitUtils;
var WritersEditorError;
(function (WritersEditorError) {
    // Unexpected response errors
    WritersEditorError[WritersEditorError["FetchError"] = 1000] = "FetchError";
    WritersEditorError[WritersEditorError["TextParsingError"] = 1001] = "TextParsingError";
    WritersEditorError[WritersEditorError["JSONParsingError"] = 1002] = "JSONParsingError";
    WritersEditorError[WritersEditorError["MissingErrorStatus"] = 1003] = "MissingErrorStatus";
    WritersEditorError[WritersEditorError["InvalidErrorStatus"] = 1004] = "InvalidErrorStatus";
    WritersEditorError[WritersEditorError["MissingErrorBody"] = 1005] = "MissingErrorBody";
    WritersEditorError[WritersEditorError["InvalidErrorBody"] = 1006] = "InvalidErrorBody";
    WritersEditorError[WritersEditorError["MissingBody"] = 1007] = "MissingBody";
    WritersEditorError[WritersEditorError["MissingPlainText"] = 1008] = "MissingPlainText";
    // API response errors
    WritersEditorError[WritersEditorError["MissingOwnerEditors"] = 2000] = "MissingOwnerEditors";
})(WritersEditorError || (WritersEditorError = {}));
var FetchMethod;
(function (FetchMethod) {
    FetchMethod["GET"] = "GET";
    FetchMethod["POST"] = "POST";
})(FetchMethod || (FetchMethod = {}));
var BCUrlPath;
(function (BCUrlPath) {
    BCUrlPath["AddEditor"] = "/ca/addEditor";
    BCUrlPath["RemoveEditor"] = "/ca/removeEditor";
    BCUrlPath["ListEditors"] = "/ca/findOwnerEditors";
    BCUrlPath["OwnerOf"] = "/m/storyverse_plot/methods/ownerOf";
})(BCUrlPath || (BCUrlPath = {}));
var BCParam;
(function (BCParam) {
    BCParam["TokenId"] = "tokenId";
    BCParam["Editor"] = "editor";
})(BCParam || (BCParam = {}));
function isWalletReady(wallet) {
    if (!wallet) {
        return false;
    }
    if (!wallet.flags.loggedIn) {
        return false;
    }
    if (!wallet.messageAndSig) {
        return false;
    }
    if (!wallet.messageAndSig.message || !wallet.messageAndSig.signature) {
        return false;
    }
    return true;
}
class WriterService {
    constructor(config) {
        this.config = config;
        this.walletService = config.walletService;
    }
    async addWriter({ tokenId, address, skipList }) {
        const editRequest = {
            [BCParam.TokenId]: tokenId,
            [BCParam.Editor]: address,
        };
        const result = await this.apiFetch(FetchMethod.POST, BCUrlPath.AddEditor, {
            body: editRequest,
            withSig: true,
            plainTextResponse: true,
        });
        log$3('addWriter', result);
        if (skipList) {
            return null;
        }
        return await this.fetchWriters({ tokenId });
    }
    async removeWriter({ tokenId, address, skipList }) {
        const editRequest = {
            [BCParam.TokenId]: tokenId,
            [BCParam.Editor]: address,
        };
        const result = await this.apiFetch(FetchMethod.POST, BCUrlPath.RemoveEditor, {
            body: editRequest,
            withSig: true,
            plainTextResponse: true,
        });
        log$3('removeWriter', result);
        if (skipList) {
            return null;
        }
        return await this.fetchWriters({ tokenId });
    }
    async fetchWriters({ tokenId }) {
        const params = new URLSearchParams({
            [BCParam.TokenId]: tokenId,
        });
        const result = await this.apiFetch(FetchMethod.GET, BCUrlPath.ListEditors, { params });
        if (!result.ownerEditors) {
            const errorCode = WritersEditorError.MissingOwnerEditors;
            log$3('Error in fetching writers:', errorCode);
            throw new Error(`Unexpected writers error (code: ${errorCode})`);
        }
        const owner = result.ownerEditors[0]?.owner_address;
        // map to writers format
        const writers = result.ownerEditors
            .map((ownerEditor) => {
            if (!ownerEditor.editor_address) {
                log$3('fetchWriters: Missing editor_address');
                return null;
            }
            return ownerEditor.editor_address;
        })
            // filter out empty/null
            .filter((writer) => !!writer)
            .map((writer) => ({ address: writer }));
        return { owner, writers };
    }
    async isCurrentOwner({ tokenId }) {
        const loggedIn = await this.walletService.logIn();
        if (!loggedIn) {
            throw new Error('Not logged in');
        }
        const wallet = await this.walletService.getWallet();
        if (!isWalletReady(wallet)) {
            throw new Error('Wallet not properly connected.');
        }
        const params = new URLSearchParams();
        params.append(BCParam.TokenId, tokenId);
        const plotOwner = await this.apiFetch(FetchMethod.GET, BCUrlPath.OwnerOf, {
            params,
            plainTextResponse: true,
            retryAttempts: 3,
        });
        return plotOwner.toLowerCase() === wallet.address.toLowerCase();
    }
    async apiFetch(method, path, options) {
        const { params, body, withSig = false, plainTextResponse = false, retryAttempts = 0, retryDelay = 2000, } = { ...options };
        // get wallet if applicable
        let wallet = null;
        if (withSig) {
            const loggedIn = this.walletService.logIn();
            if (!loggedIn) {
                throw new Error('Not logged in');
            }
            wallet = await this.walletService.getWallet();
            if (!isWalletReady(wallet)) {
                throw new Error('Wallet not properly connected.');
            }
        }
        // build URL
        const urlObj = new URL(this.config.serviceProxyUrl + path);
        params?.forEach((value, key) => urlObj.searchParams.append(key, value));
        const url = urlObj.toString();
        // optional request body
        let requestBody = null;
        if (body || withSig) {
            requestBody = {};
        }
        if (withSig) {
            requestBody.signature = wallet.messageAndSig.signature;
            requestBody.message = wallet.messageAndSig.message;
        }
        if (body) {
            requestBody = {
                ...requestBody,
                ...body,
            };
        }
        // send fetch
        let response;
        for (let tries = 0; tries <= retryAttempts && !response?.ok; tries += 1) {
            try {
                const request = { method };
                if (requestBody) {
                    request.body = JSON.stringify(requestBody);
                    request.headers = {
                        'Content-Type': 'application/json',
                    };
                }
                response = await fetch(url, request);
            }
            catch (e) {
                console.error('Error while editing writers:', e);
                if (tries >= retryAttempts) {
                    throw new Error(`Unexpected writers error (${WritersEditorError.FetchError})`);
                }
                else {
                    await waitForMs(retryDelay);
                }
            }
        }
        // parse plaintext
        if (plainTextResponse) {
            // typing shenanigans
            return (await this.parsePlainText(response));
        }
        // parse body with error parsing
        const responseBody = await this.parseBody(response);
        return responseBody;
    }
    async parsePlainText(result) {
        let text;
        try {
            text = await result.text();
        }
        catch (e) {
            console.error('Error in editing writers while parsing plaintext:', e);
            throw new Error(`Unexpected writers error (code: ${WritersEditorError.TextParsingError})`);
        }
        if (!text?.length) {
            const errorCode = WritersEditorError.MissingPlainText;
            console.error('Error in editing writers:', errorCode);
            throw new Error(`Unexpected writers error (code: ${errorCode})`);
        }
        return text;
    }
    async parseBody(result) {
        let plainText;
        let data;
        try {
            plainText = await result.text();
        }
        catch (e) {
            console.error('Error in editing writers while parsing plaintext:', e);
            throw new Error(`Unexpected writers error (code: ${WritersEditorError.TextParsingError})`);
        }
        try {
            data = JSON.parse(plainText);
        }
        catch (e) {
            // maybe error message is in plain text
            if (!result.ok) {
                console.error('Error in editing writers:', result.status, plainText);
                throw new Error(`Error: ${plainText}`);
            }
            // success response needs to be JSON, so throw an error
            const errorCode = WritersEditorError.JSONParsingError;
            console.error('Error in editing writers:', errorCode, e);
            throw new Error(`Unexpected writers error (code: ${errorCode})`);
        }
        if (!('statusCode' in data)) {
            const errorCode = WritersEditorError.MissingErrorStatus;
            console.error('Error in editing writers:', errorCode);
            throw new Error(`Unexpected writers error (code: ${errorCode})`);
        }
        if (typeof data.statusCode !== 'number') {
            const errorCode = WritersEditorError.InvalidErrorStatus;
            console.error('Error in editing writers:', errorCode);
            throw new Error(`Unexpected writers error (code: ${errorCode})`);
        }
        // we care about the data status code
        const statusCode = data.statusCode;
        if (statusCode < 200 || statusCode >= 300) {
            // treat as error
            if (!data.body) {
                const errorCode = WritersEditorError.MissingErrorBody;
                console.error('Error in editing writers:', errorCode);
                throw new Error(`Unexpected writers error (code: ${errorCode})`);
            }
            if (typeof data.body !== 'string') {
                const errorCode = WritersEditorError.InvalidErrorBody;
                console.error('Error in editing writers:', errorCode);
                throw new Error(`Unexpected writers error (code: ${errorCode})`);
            }
            console.error('Error from API:', data.statusCode, data.body);
            throw new Error(data.body);
        }
        if (!('body' in data)) {
            const errorCode = WritersEditorError.MissingBody;
            console.error('Error in editing writers:', errorCode);
            throw new Error(`Unexpected writers error (code: ${errorCode})`);
        }
        return data.body;
    }
}

class SaleService {
    contestStatus(_opts) {
        throw new Error('Method not implemented.');
    }
    publicSignAndMint(_opts) {
        throw new Error('Method not implemented.');
    }
    fetchSaleContractInfo(_opts) {
        throw new Error('Method not implemented.');
    }
}

const { tokenReplace } = lib.StringUtils;
const { waitForExpectedValue } = lib.WaitUtils;
const log$2 = debug$1('app:common:SvsRestApi');
var AuthEndpoint;
(function (AuthEndpoint) {
    AuthEndpoint["Authorize"] = "/twitter/authorize/{authVersion}";
    AuthEndpoint["Refresh"] = "/twitter/refresh";
    AuthEndpoint["Verify"] = "/twitter/verify/{authVersion}";
})(AuthEndpoint || (AuthEndpoint = {}));
var MediaServiceEndpoint;
(function (MediaServiceEndpoint) {
    MediaServiceEndpoint["FollowVerify"] = "/verify";
    MediaServiceEndpoint["UploadVideo"] = "/upload";
    MediaServiceEndpoint["Tweet"] = "/tweet";
})(MediaServiceEndpoint || (MediaServiceEndpoint = {}));
var PipelineEndpoint;
(function (PipelineEndpoint) {
    PipelineEndpoint["AddToPending"] = "/tw/authV2/addToPending";
    PipelineEndpoint["Pending"] = "/tw/authV2/pending/{pendingKey}";
    PipelineEndpoint["Chainalysis"] = "/chainalysis/{walletAddress}";
    PipelineEndpoint["Tokenproof"] = "/tp/{nonce}";
    PipelineEndpoint["WlAdd"] = "/wl/{tokenType}/waitlist";
    PipelineEndpoint["WlSpotsRemaining"] = "/wl/{tokenType}/spots/remaining";
    PipelineEndpoint["SignForMint"] = "/mint/{tokenType}/signForMint/{premint}";
    PipelineEndpoint["StoryNFTSignForMint"] = "/mint/storyNFT/{tokenType}/0/signForMint/";
    PipelineEndpoint["WaitForMintingOf"] = "/mint/{tokenType}/waitForMintingOf";
    PipelineEndpoint["TokenThumbnails"] = "/mint/{tokenType}/tokenThumbnails";
    PipelineEndpoint["TweetStory"] = "/twitter/tweetStory";
    PipelineEndpoint["TweetVideo"] = "/twitter/tweetVideo";
    PipelineEndpoint["Preshare"] = "/preshare/{walletAddress}/{storyId}";
    PipelineEndpoint["SetClaimed"] = "/mint/contestStatus/{contractKey}/{walletAddress}?claim=1";
    PipelineEndpoint["oneoffAirDrop"] = "/mint/{tokenType}/oneoffAirDrop";
    PipelineEndpoint["GetContestStatus"] = "/mint/contestStatus/{contractKey}/{walletAddress}";
    PipelineEndpoint["GetMintFee"] = "/mint/ethPerUsd";
    PipelineEndpoint["MarketingCampaign"] = "/marketing/{campaign}/{walletAddress}";
    PipelineEndpoint["ProjectMarketingCampaign"] = "/marketing/{project}/{campaign}/{walletAddress}";
    PipelineEndpoint["TwitterVerifyCreds"] = "/twitter/verify/keys";
})(PipelineEndpoint || (PipelineEndpoint = {}));
var MbaasEndpoint;
(function (MbaasEndpoint) {
    MbaasEndpoint["Mint"] = "/api/v0/chains/ethereum/addresses/{addressLabel}/contracts/{sharedLabel}/methods/signatureMint";
})(MbaasEndpoint || (MbaasEndpoint = {}));
/**
 * Temporary; we should transition this to using svs-config-client when the time comes.
 */
let config = null;
/**
 * Temporary; we should transition this to using svs-config-client when the time comes.
 */
function setSvsRestApiConfig(c) {
    config = c;
}
function getAuthEndpoint(endpoint, tokens = {}) {
    if (!config) {
        throw new Error('getAuthEndpoint: config not initialized');
    }
    return `${config.authBaseUrl}${tokenReplace(endpoint, tokens, true)}`;
}
function getMediaServiceEndpoint(endpoint, tokens = {}) {
    if (!config) {
        throw new Error('getMediaServiceEndpoint: config not initialized');
    }
    return `${config.mediaServiceBaseUrl}${tokenReplace(endpoint, tokens, true)}`;
}
function getPipelineEndpoint(endpoint, tokens = {}) {
    if (!config) {
        throw new Error('getPipelineEndpoint: config not initialized');
    }
    return `${config.pipelineBaseUrl}${tokenReplace(endpoint, tokens, true)}`;
}
async function apiCall(opts) {
    const { headers, ...restInit } = opts.requestInit ?? {};
    const maybeHeaders = {};
    if (opts.body && (opts.method.toUpperCase() === 'POST' || opts.method.toUpperCase() === 'PUT')) {
        maybeHeaders['Content-Type'] = lib.ContentType.Json;
    }
    const requestInit = {
        method: opts.method,
        headers: {
            ...maybeHeaders,
            ...headers,
        },
        cache: 'no-cache',
        ...restInit,
    };
    if (opts.body) {
        requestInit.body = JSON.stringify(opts.body);
    }
    if (opts.retryOpts) {
        const { promise } = waitForExpectedValue(async () => {
            const response = await fetch(opts.url, requestInit);
            if (!response.ok) {
                const text = await response.text();
                throw new Error(`Error (${response.status}) response: ${text}`);
            }
            return response;
        }, opts.retryOpts);
        return await promise;
    }
    const response = await fetch(opts.url, requestInit);
    return response;
}
async function formatResponse(response) {
    const headers = {};
    response.headers?.forEach((value, key) => {
        headers[key.toLowerCase()] = value;
    });
    const responseContentType = headers['content-type']?.trim() ?? lib.ContentType.Json;
    const str = await response.text();
    if (responseContentType.includes(lib.ContentType.Json)) {
        try {
            return JSON.parse(str);
        }
        catch (e) {
            log$2('Invalid JSON format, using text instead:', e.message);
            return str;
        }
    }
    if (responseContentType.includes(lib.ContentType.Form)) {
        return new URLSearchParams(str).toString();
    }
    // html, text, default
    return str;
}
// defensive: splitting to avoid compiler from treating it as an actual tag
const preStartTag = '<pr' + 'e>';
const preEndTag = '</pr' + 'e>';
function formatPipelineErrorResponse(message) {
    const preStartTagIndex = message.indexOf(preStartTag);
    const preEndTagIndex = message.indexOf(preEndTag);
    // if one or both don't exist, just return message as is
    if (preStartTagIndex === -1 || preEndTagIndex === -1) {
        return message;
    }
    return message.substring(preStartTagIndex + preStartTag.length, preEndTagIndex);
}
async function mediaServiceApiCall({ method, endpoint, body, tokens = {}, requestInit, retryOpts, }) {
    const url = getMediaServiceEndpoint(endpoint, tokens);
    const response = await apiCall({
        method,
        url,
        body,
        requestInit,
        retryOpts,
    });
    if (!response.ok) {
        let authError = false;
        const errorStr = await response.text();
        // older response type for auth error
        if (response.status === 400) {
            try {
                const errorData = JSON.parse(errorStr);
                if (errorData.message === 'Auth error') {
                    authError = true;
                }
            }
            catch (e) {
                // do nothing, just do normal RestApierror
            }
        }
        // newer response type for auth error
        if (response.status === 401 || response.status === 403) {
            authError = true;
        }
        if (authError) {
            throw new lib.SvsErrors.SvsAuthError(`Auth error (status: ${response.status})`);
        }
        log$2(`Media service error (status: ${response.status}):`, errorStr);
        throw new lib.SvsErrors.SvsRestApiError(response.status, `Media service error (status: ${response.status})`, errorStr);
    }
    return await formatResponse(response);
}
async function pipelineApiCall({ method, endpoint, tokens = {}, body, requestInit, retryOpts, }) {
    const url = getPipelineEndpoint(endpoint, tokens);
    const response = await apiCall({
        url,
        method,
        body,
        requestInit,
        retryOpts,
    });
    if (!response.ok) {
        const errorStr = formatPipelineErrorResponse(await response.text());
        log$2(`Pipeline error (status: ${response.status}, method: ${method}, endpoint: ${endpoint}): ${errorStr}`);
        throw new lib.SvsErrors.SvsRestApiError(response.status, `Pipeline error (status: ${response.status})`, errorStr);
    }
    return await formatResponse(response);
}

function isPipelineTweetResponse(obj) {
    if (!obj) {
        return false;
    }
    if (typeof obj.tweetId !== 'string') {
        return false;
    }
    return Boolean(obj.tweetId);
}
class TwtShareBuilder {
    constructor(optsOrBuilder) {
        if (optsOrBuilder) {
            // these are separate because TS lang server does not pick up these in a grouped "OR", probably
            // because of "instanceof"
            if (optsOrBuilder instanceof TwtShareBuilder) {
                this._message = optsOrBuilder._message;
                this._creds = optsOrBuilder._creds;
            }
            else {
                if (typeof optsOrBuilder.message === 'string') {
                    this._message = optsOrBuilder.message;
                }
                if (lib.isTwtCreds(optsOrBuilder.creds)) {
                    this._creds = optsOrBuilder.creds;
                }
            }
        }
    }
    message(msg) {
        this._message = msg;
        return this;
    }
    creds(c) {
        this._creds = c;
        return this;
    }
    async video(videoShareOpts) {
        this.checkIfValid();
        const credsBody = this.createCredsBody();
        const body = {
            tweet: {
                message: this._message,
            },
            videoUrl: videoShareOpts.videoUrl,
            ...credsBody,
        };
        const data = await pipelineApiCall({
            method: 'POST',
            endpoint: PipelineEndpoint.TweetVideo,
            body,
        });
        if (!isPipelineTweetResponse(data)) {
            throw new lib.SvsErrors.SvsRestApiError(0, 'share video: Invalid response data format', data ? JSON.stringify(data) : undefined, 'Share video error occurred');
        }
        return data.tweetId;
    }
    async story(storyShareOpts) {
        this.checkIfValid();
        const credsBody = this.createCredsBody();
        const body = {
            tweet: {
                message: this._message,
            },
            storyKey: `${storyShareOpts.authorAddress}/${storyShareOpts.storyId}`,
            ...credsBody,
        };
        const data = await pipelineApiCall({
            method: 'POST',
            endpoint: PipelineEndpoint.TweetStory,
            body,
        });
        if (!isPipelineTweetResponse(data)) {
            throw new lib.SvsErrors.SvsRestApiError(0, 'share story: Invalid response data format', data ? JSON.stringify(data) : undefined, 'Share story error occurred');
        }
        return data.tweetId;
    }
    checkIfValid() {
        if (!this._message) {
            throw new Error('Missing message');
        }
        if (!this._creds) {
            throw new Error('Missing creds');
        }
        if (!lib.isTwtCreds(this._creds)) {
            throw new Error('Invalid creds');
        }
    }
    createCredsBody() {
        if (!this._creds) {
            throw new Error('Missing creds');
        }
        if (!lib.isTwtCreds(this._creds)) {
            throw new Error('Invalid creds');
        }
        return lib.isTwtCredsV1(this._creds)
            ? {
                accessToken: this._creds.accessToken,
                accessTokenSecret: this._creds.accessTokenSecret,
            }
            : {
                bearerToken: this._creds.bearerToken,
            };
    }
    static create(opts) {
        return new TwtShareBuilder(opts);
    }
}

const log$1 = debug('svsnavbar:twitterservice');
const authMapStorageKey = 'svs.nb.twt.a:1.0.0';
function isAuthMap(obj) {
    return (obj &&
        typeof obj === 'object' &&
        (!obj[lib.TwtAuthVersion.V1Write] || lib.isTwtCredsV1(obj[lib.TwtAuthVersion.V1Write])) &&
        (!obj[lib.TwtAuthVersion.V1Read] || lib.isTwtCredsV1(obj[lib.TwtAuthVersion.V1Read])) &&
        (!obj[lib.TwtAuthVersion.V2] || lib.isTwtCredsV2(obj[lib.TwtAuthVersion.V2])));
}
const authAliasMap = {
    v1: lib.TwtAuthVersion.V1Write,
};
function isAuthTupleV1(obj) {
    return Array.isArray(obj) && obj.length >= 4 && obj.every((item) => typeof item === 'string');
}
function isFollowVerifyResponse(obj) {
    if (!obj) {
        return false;
    }
    if (typeof obj.followingAccounts !== 'object') {
        return false;
    }
    return Object.values(obj.followingAccounts).every((value) => typeof value === 'boolean');
}
function authTupleToTwtCreds({ authTupleV1, authTupleV2 }) {
    if (authTupleV1) {
        return authTupleV1ToTwtCredsV1(authTupleV1);
    }
    if (authTupleV2) {
        return authTupleV2ToTwtCredsV2(authTupleV2);
    }
    throw new Error('Error (authTupleToTwtCreds): At least one param is required.');
}
function authTupleV1ToTwtCredsV1(authTuple) {
    let authVersion = authTuple[4] ?? lib.TwtAuthVersion.V1Write;
    if (authAliasMap[authVersion]) {
        authVersion = authAliasMap[authVersion];
    }
    return {
        authVersion,
        userId: authTuple[0],
        userName: authTuple[1],
        accessToken: authTuple[2],
        accessTokenSecret: authTuple[3],
    };
}
function authTupleV2ToTwtCredsV2(authTuple) {
    const [userId, handle, bearerToken, refreshToken, _version, _usage] = authTuple;
    return {
        authVersion: lib.TwtAuthVersion.V2,
        userId,
        userName: handle,
        bearerToken,
        refreshToken,
    };
}
function isMetaMaskMobile() {
    return userAgent.string.toLowerCase().includes('metamaskmobile');
}
class TwitterService {
    constructor(config) {
        this.config = config;
        this.authMap = {};
        this.recentlyLoggedIn = false;
        this.redirectError = null;
        this.auth = {
            get: this.getTwtUser.bind(this),
            canRead: () => Promise.resolve(this.hasCreds(lib.TwtAuthVersion.V1Read) && this.checkIfValidTwitterCreds(lib.TwtAuthVersion.V1Read)),
            canWrite: () => Promise.resolve(this.hasCreds(lib.TwtAuthVersion.V1Write) && this.checkIfValidTwitterCreds(lib.TwtAuthVersion.V1Write)),
            logIn: this.logIn.bind(this),
            logOut: this.logOut.bind(this),
            recentlyLoggedIn: () => Promise.resolve(this.recentlyLoggedIn),
            erroredOnRedirect: () => Promise.resolve(this.redirectError),
        };
        this.share = {
            story: (opts) => {
                if (!this.authMap[lib.TwtAuthVersion.V1Write] || !this.checkIfValidTwitterCreds(lib.TwtAuthVersion.V1Write)) {
                    return Promise.reject(new lib.SvsErrors.RequiresTwtAuthError(lib.TwtAuthVersion.V1Write));
                }
                return TwtShareBuilder.create().creds(this.authMap[lib.TwtAuthVersion.V1Write]).message(opts.message).story({
                    authorAddress: opts.authorAddress,
                    storyId: opts.storyId,
                });
            },
            video: (opts) => {
                if (!this.authMap[lib.TwtAuthVersion.V1Write] || !this.checkIfValidTwitterCreds(lib.TwtAuthVersion.V1Write)) {
                    return Promise.reject(new lib.SvsErrors.RequiresTwtAuthError(lib.TwtAuthVersion.V1Write));
                }
                return TwtShareBuilder.create().creds(this.authMap[lib.TwtAuthVersion.V1Write]).message(opts.message).video({
                    videoUrl: opts.videoUrl,
                });
            },
        };
        this.loadAuthMap();
        this.initAuth();
    }
    async fetchIsFollowingAll({ userNames }) {
        const creds = this.authMap[lib.TwtAuthVersion.V1Write];
        if (!creds) {
            throw new lib.SvsErrors.RequiresTwtAuthError(lib.TwtAuthVersion.V1Write);
        }
        if (!userNames.length) {
            return {};
        }
        const body = {
            followCheckList: userNames,
            accessToken: creds.accessToken,
            accessSecret: creds.accessTokenSecret,
            apiVersion: 'v1write', // realistically auth version
        };
        const data = await mediaServiceApiCall({
            method: 'POST',
            endpoint: MediaServiceEndpoint.FollowVerify,
            body,
        });
        if (!isFollowVerifyResponse(data)) {
            throw new lib.SvsErrors.SvsRestApiError(0, 'fetchIsFollowingAll error: Invalid data format', JSON.stringify(data));
        }
        return data.followingAccounts;
    }
    async trackMarketingAnalytics({ project, campaign, walletAddress, emailAddress, token, }) {
        // any creds will do, as long as it has a userName
        const creds = Object.values(this.authMap).find((c) => Boolean(c?.userName));
        if (!creds) {
            // at least a v1read
            throw new lib.SvsErrors.RequiresTwtAuthError(lib.TwtAuthVersion.V1Read);
        }
        const endpoint = project ? PipelineEndpoint.ProjectMarketingCampaign : PipelineEndpoint.MarketingCampaign;
        const body = {
            socialHandles: {
                hotWallet: walletAddress,
                email: emailAddress,
            },
            token,
        };
        try {
            await pipelineApiCall({
                method: 'POST',
                endpoint,
                tokens: {
                    project,
                    campaign,
                    walletAddress,
                },
                body,
            });
        }
        catch (e) {
            if (lib.SvsErrors.SvsRestApiError.isError(e) && e.statusCode === 409) {
                throw new lib.SvsErrors.SvsAlreadySubbedError([
                    'This wallet or Twitter account was already entered',
                    `campaign: ${campaign}`,
                    `project: ${project ?? 'n/a'}`,
                    `wallet address: ${walletAddress}`,
                    `twitter: ${creds.userName}`,
                ].join('\n'));
            }
            throw e;
        }
    }
    initAuth() {
        const urlParams = new URLSearchParams(window.location.search);
        let paramsChanged = false;
        if (urlParams.has(lib.TwtSearchParam.Auth)) {
            this.initAuthFromRedirect(urlParams.get(lib.TwtSearchParam.Auth));
            urlParams.delete(lib.TwtSearchParam.Auth);
            paramsChanged = true;
        }
        if (urlParams.has(lib.TwtSearchParam.AuthError)) {
            this.initAuthErrorFromRedirect(urlParams.get(lib.TwtSearchParam.AuthError));
            urlParams.delete(lib.TwtSearchParam.AuthError);
            paramsChanged = true;
        }
        if (paramsChanged) {
            const path = `${window.location.pathname}?${urlParams.toString()}`;
            window.history.replaceState(null, '', path);
        }
    }
    initAuthFromRedirect(authValueStr) {
        if (!authValueStr) {
            return;
        }
        let authValue;
        try {
            authValue = JSON.parse(authValueStr);
        }
        catch (e) {
            log$1('Invalid auth value from param:', e);
            return;
        }
        const authKey = isAuthTupleV1(authValue) ? 'authTupleV1' : 'authTupleV2';
        const creds = authTupleToTwtCreds({ [authKey]: authValue });
        // if not the same user Id, clear other auth
        if (!Object.values(this.authMap).every((c) => !c || c.userId === creds.userId)) {
            this.authMap = {};
            log$1('Not same user; clearing auth map');
        }
        // @ts-ignore - i dont know how to fix the type here, it should have understood 🤷
        this.authMap[creds.authVersion] = creds;
        this.saveAuthMap();
        this.recentlyLoggedIn = true;
        log$1('initialized twt auth for', creds.userName);
    }
    initAuthErrorFromRedirect(authErrorValueStr) {
        if (!authErrorValueStr) {
            return;
        }
        let error;
        if (authErrorValueStr === lib.TwtAuthErrorType.Denied) {
            error = new lib.SvsErrors.TwtAuthDeniedError();
        }
        else {
            error = new lib.SvsErrors.TwtAuthError(authErrorValueStr);
        }
        this.redirectError = error;
    }
    getTwtUser() {
        for (const creds of Object.values(this.authMap)) {
            if (creds) {
                const user = {
                    handle: creds.userName,
                    id: creds.userId,
                };
                if (creds.authVersion === lib.TwtAuthVersion.V2) {
                    user.bearerToken = creds.bearerToken;
                    user.refreshToken = creds.refreshToken;
                }
                return Promise.resolve(user);
            }
        }
        return Promise.resolve(null);
    }
    hasCreds(authVersion) {
        return Boolean(this.authMap[authVersion]);
    }
    logIn(opts) {
        const existingCreds = this.authMap[opts.authVersion];
        if (!opts.force && existingCreds) {
            return Promise.resolve({
                handle: existingCreds.userName,
                id: existingCreds.userId,
            });
        }
        const authUrl = getAuthEndpoint(AuthEndpoint.Authorize, { authVersion: opts.authVersion });
        const url = new URL(authUrl);
        url.searchParams.append('redir', opts?.redirectUrl ?? window.location.href);
        if (opts.authVersion === lib.TwtAuthVersion.V2) {
            url.searchParams.append('usage', opts?.usage || 'followVerify');
        }
        if (isMetaMaskMobile()) {
            if (userAgent.os.isAndroid) {
                url.searchParams.append('metamask', 'android');
            }
            else if (userAgent.os.isIOS) {
                url.searchParams.append('metamask', 'ios');
            }
        }
        if (opts.newTab) {
            window.open(url.toString(), '_blank');
        }
        else {
            window.location.href = url.toString();
        }
        // a non-resolving promise
        return new Promise(() => { });
    }
    logOut() {
        this.authMap = {};
        this.saveAuthMap();
        return Promise.resolve();
    }
    saveAuthMap() {
        localStorage.setItem(authMapStorageKey, JSON.stringify(this.authMap));
    }
    loadAuthMap() {
        const authMapStr = localStorage.getItem(authMapStorageKey);
        if (!authMapStr) {
            return;
        }
        let authMapValue;
        try {
            authMapValue = JSON.parse(authMapStr);
        }
        catch (e) {
            log$1('auth map value not JSON');
            return;
        }
        if (!isAuthMap(authMapValue)) {
            log$1('auth map value not valid');
            return;
        }
        this.authMap = authMapValue;
    }
    async checkIfValidTwitterCreds(authVersion) {
        const creds = this.authMap[authVersion];
        const body = {
            data: {
                accessToken: creds.accessToken,
                accessTokenSecret: creds.accessTokenSecret,
                accountType: authVersion,
            },
        };
        const data = await pipelineApiCall({
            method: 'POST',
            endpoint: PipelineEndpoint.TwitterVerifyCreds,
            body,
        });
        if (data['validCreds'] === false) {
            // clear creds
            this.authMap[authVersion] = undefined;
            this.saveAuthMap();
        }
        return data['validCreds'];
    }
}

const log = debug('svsnavbar:bridge');
let defaultWalletService = null;
let defaultWritersApi = null;
let defaultSaleApi = null;
let defaultTwitterService = null;
function getOrCreateWalletService(config) {
    if (!defaultWalletService) {
        // defaultWalletService = new MultiWalletService(config)
        defaultWalletService = new WCWalletService(config);
    }
    return defaultWalletService;
}
function getOrCreateWritersApi(config) {
    if (!defaultWritersApi) {
        defaultWritersApi = new WriterService(config);
    }
    return defaultWritersApi;
}
function getOrCreateSaleApi(_config) {
    if (!defaultSaleApi) {
        defaultSaleApi = new SaleService();
    }
    return defaultSaleApi;
}
function getOrCreateTwitterService(config) {
    if (!defaultTwitterService) {
        defaultTwitterService = new TwitterService(config);
    }
    return defaultTwitterService;
}
class SvsBridge extends EventEmitter {
    constructor(opts) {
        super();
        setSvsRestApiConfig(opts);
        this.walletService = opts.walletService ?? getOrCreateWalletService(opts);
        this.writersApi =
            opts.writersApi ??
                getOrCreateWritersApi({
                    serviceProxyUrl: opts.serviceProxyUrl,
                    walletService: this.walletService,
                });
        this.walletService.on(lib.SvsNavbarEvent.Any, this.onAny, this);
        if (opts.autoWalletInit) {
            this.walletService.init({ providerType: opts.autoWalletInit });
        }
        this._saleApi =
            opts.saleApi ??
                getOrCreateSaleApi({
                    serviceProxyUrl: opts.serviceProxyUrl,
                    walletService: this.walletService,
                });
        this.twitterService = opts.twitterService ?? getOrCreateTwitterService(opts);
        this._api = this.createMethods();
    }
    get api() {
        return this._api;
    }
    get saleApi() {
        return this._saleApi;
    }
    async isWeb3Capable() {
        const provider = await detectEthereumProvider();
        return Boolean(provider);
    }
    async connect(iframe) {
        if (this.connection) {
            await this.disconnect();
        }
        this.iframe = iframe;
        log('Creating connection...');
        this.connection = connectToChild({
            iframe,
            methods: this.createMethods(),
        });
        log('Waiting for connection...');
        this.client = await this.connection.promise;
        log('Connection established.');
        return this;
    }
    async disconnect() {
        if (!this.connection) {
            return this;
        }
        this.iframe = null;
        this.client = null;
        this.connection.destroy();
        this.connection = null;
        log('Connection destroyed.');
        return this;
    }
    triggerClientShare(shareData) {
        this.client?.onNavbarEvent(lib.SvsNavbarEvent.TriggerShare, shareData);
    }
    sendClientEvent(evt, opts) {
        this.client?.onNavbarEvent(evt, opts);
    }
    emitAndSendClientEvent(evt, opts) {
        this.emit(evt, opts);
        this.sendClientEvent(evt, opts);
    }
    getWagmiClient() {
        return this.walletService.getWagmiClient();
    }
    getW3MEthereumClient() {
        return this.walletService.getW3MEthereumClient();
    }
    emit(event, ...args) {
        // Overriding to emulate an "any" event
        const emitted = super.emit(event, ...args);
        super.emit(lib.SvsNavbarEvent.Any, event, ...args);
        return emitted;
    }
    on(event, fn, context) {
        return super.on(event, fn, context);
    }
    once(event, fn, context) {
        return super.once(event, fn, context);
    }
    off(event, fn, context) {
        return super.off(event, fn, context);
    }
    createMethods() {
        return {
            init: this.walletService.init.bind(this.walletService),
            getWallet: this.walletService.getWallet.bind(this.walletService),
            logIn: this.walletService.logIn.bind(this.walletService),
            signSession: this.walletService.signSession.bind(this.walletService),
            logOut: this.walletService.logOut.bind(this.walletService),
            isLoggedIn: () => this.walletService.waitForInit().then(() => this.walletService.loggedIn),
            isWeb3Available: this.walletService.isWeb3Available.bind(this.walletService),
            changeSvsProvider: this.walletService.changeSvsProvider.bind(this.walletService),
            getSvsProvider: this.walletService.getSvsProvider.bind(this.walletService),
            saveStory: this.walletService.saveStory.bind(this.walletService),
            saveStoryForShare: this.walletService.saveStoryForShare.bind(this.walletService),
            getTemplatesFor: this.walletService.getTemplatesFor.bind(this.walletService),
            getAvailableAssets: this.walletService.getAvailableAssets.bind(this.walletService),
            authorizeChoiceCreation: this.walletService.authorizeChoiceCreation.bind(this.walletService),
            authorizeOptionMinting: this.walletService.authorizeOptionMinting.bind(this.walletService),
            sendTransaction: this.walletService.sendTransaction.bind(this.walletService),
            getTransactionReceipt: this.walletService.getTransactionReceipt.bind(this.walletService),
            onClientEvent: this.onClientEvent.bind(this),
            // safer to do bind individual functions
            writers: {
                addWriter: this.writersApi.addWriter.bind(this.writersApi),
                removeWriter: this.writersApi.removeWriter.bind(this.writersApi),
                fetchWriters: this.writersApi.fetchWriters.bind(this.writersApi),
                isCurrentOwner: this.writersApi.isCurrentOwner.bind(this.writersApi),
            },
            saleService: {
                contestStatus: this.saleApi.contestStatus.bind(this.saleApi),
                publicSignAndMint: this.saleApi.publicSignAndMint.bind(this.saleApi),
                fetchSaleContractInfo: this.saleApi.fetchSaleContractInfo.bind(this.saleApi),
            },
            twitterService: {
                auth: this.twitterService.auth,
                share: this.twitterService.share,
                fetchIsFollowingAll: this.twitterService.fetchIsFollowingAll.bind(this.twitterService),
                trackMarketingAnalytics: this.twitterService.trackMarketingAnalytics.bind(this.twitterService),
            },
            savePlotTitle: this.walletService.savePlotTitle.bind(this.walletService),
            // story nft
            getNFTStoryForStoryWriter: this.walletService.getNFTStoryForStoryWriter.bind(this.walletService),
            saveNftStoryForWriter: this.walletService.saveNftStoryForWriter.bind(this.walletService),
            recordChoice: this.walletService.recordChoice.bind(this.walletService),
            isNFTStoryOwner: this.walletService.isNFTStoryOwner.bind(this.walletService),
            randomReveal: this.walletService.randomReveal.bind(this.walletService),
            getNFTStory: this.walletService.getNFTStory.bind(this.walletService),
        };
    }
    onAny(event, ...args) {
        this.emit(event, ...args);
        if (!this.client || !this.client.onNavbarEvent) {
            return;
        }
        this.client.onNavbarEvent(event, ...args);
    }
    onClientEvent(event, ...args) {
        this.emit(event, ...args);
    }
}

var StaticLoadingVideo = lib.StaticLoadingVideo;
var SvsErrors$1 = lib.SvsErrors;
var SvsNavbarEvent$1 = lib.SvsNavbarEvent;
var SvsProvider$1 = lib.SvsProvider;
var TwtAuthVersion$1 = lib.TwtAuthVersion;
var WaitUtils$1 = lib.WaitUtils;
export { MultiWalletService, StaticLoadingVideo, SvsBridge, SvsErrors$1 as SvsErrors, SvsNavbarEvent$1 as SvsNavbarEvent, SvsProvider$1 as SvsProvider, SaleService as SvsSaleService, TwtAuthVersion$1 as TwtAuthVersion, WCWalletService, WaitUtils$1 as WaitUtils, loginStateFinished };
